import F, { z as f } from "zod";
import { p as xt, H as K, a as en, u as k, N as Ln, c as Dr, C as Dn, A as St, i as Hr, b as Vr, n as Hn, d as Mr, e as Gr, f as zr, g as qr, s as Q, h as nt, j as nn, k as Wr, S as Kr, l as rn, M as sn, m as Zr, o as Yr, q as Re, r as Xr, t as se, B as on, v as oe, w as Pt, x as Jr, y as Qr, z as ts, D as es, E as ns, F as rs, T as ss, G as $e, I as Vn, J as os, K as ye, L as as, O as is, P as cs, Q as ls, R as _t } from "./transactionVersion-tQTwHiJA.mjs";
import { am as Cd, aV as Od, bO as kd, aX as Pd, aT as Rd, an as $d, af as Fd, ah as Ud, ag as jd, ai as Ld, bt as Dd, bB as Hd, bh as Vd, bl as Md, a9 as Gd, aa as zd, a5 as qd, a4 as Wd, Z as Kd, W as Zd, X as Yd, Y as Xd, aM as Jd, az as Qd, au as tf, av as ef, as as nf, at as rf, ax as sf, aw as of, ay as af, ar as cf, aq as lf, ap as uf, ao as df, aA as ff, aj as hf, ab as pf, b1 as mf, b5 as gf, b3 as wf, bo as yf, bD as bf, by as Sf, bJ as Ef, ae as Af, bd as xf, b7 as vf, bf as If, bk as Tf, aD as Bf, aE as _f, aF as Nf, bL as Cf, bK as Of, bH as kf, br as Pf, aB as Rf, aC as $f, bp as Ff, aK as Uf, aG as jf, aL as Lf, aI as Df, aJ as Hf, b0 as Vf, bq as Mf, bg as Gf, bA as zf, bw as qf, bn as Wf, be as Kf, aY as Zf, $ as Yf, _ as Xf, a1 as Jf, a2 as Qf, bv as th, bu as eh, aS as nh, aZ as rh, b2 as sh, a0 as oh, aP as ah, ac as ih, a7 as ch, ak as lh, a6 as uh, aQ as dh, bC as fh, bx as hh, bc as ph, aU as mh, b9 as gh, a8 as wh, ad as yh, al as bh, aO as Sh, aH as Eh, bs as Ah, bI as xh, b8 as vh, ba as Ih, bb as Th, bi as Bh, bm as _h, bj as Nh, bF as Ch, bG as Oh, bE as kh, a3 as Ph, b4 as Rh, bz as $h, aW as Fh, a_ as Uh, aR as jh, a$ as Lh, b6 as Dh, aN as Hh, bQ as Vh, bP as Mh, bM as Gh, bR as zh, bN as qh, U as Wh, V as Kh } from "./transactionVersion-tQTwHiJA.mjs";
import { constants as Z, starknetId as Mn, CallData as mt, CairoOption as an, CairoOptionVariant as cn, hash as Gn, num as O, encode as $t, uint256 as Ht, ec as us, isSierra as ds, TransactionType as ln } from "starknet";
import { useEffect as Ft, useRef as un, useState as zn, useMemo as vt, useCallback as qn, createContext as fs } from "react";
import { isFunction as qt, isString as Wn, upperCase as Fe, isNil as hs, upperFirst as ps, lowerCase as Kn, isUndefined as ms, isEmpty as dn, isArray as gs } from "lodash-es";
import ae, { useSWRConfig as ws } from "swr";
import { hex as Zn, base58 as Yn, stringToBytes as ys } from "@scure/base";
import { UAParser as bs } from "ua-parser-js";
import { validateMnemonic as Ss } from "@scure/bip39";
import { wordlist as Es } from "@scure/bip39/wordlists/english";
import As from "object-hash";
import { jsx as xs } from "react/jsx-runtime";
const vs = f.object({
  name: f.string().optional(),
  address: f.string(),
  ownerAddress: f.string(),
  chain: f.enum(["ethereum", "zksync", "zksync2", "starknet"]),
  deploymentStatus: f.enum([
    "notDeployed",
    "deploying",
    "deployed",
    "deployError"
  ]),
  application: f.enum(["mobile", "webwallet", "argentx"]),
  guardianAddresses: f.array(f.string()).optional(),
  enabledGuardianAddresses: f.array(f.string()).optional(),
  implClassHash: f.string().optional(),
  proxyClassHash: f.string().optional(),
  salt: f.string().optional(),
  created: f.string().optional(),
  contractVersion: f.string().optional(),
  contractName: f.string().optional(),
  version: f.number().optional(),
  owner: f.object({
    guid: f.string().optional(),
    signerType: f.enum(["StarknetKey", "EthereumKey"]).optional()
  }).optional()
}), kl = f.object({
  address: f.string(),
  guardianAddress: f.string().optional(),
  account: vs
}), Pl = f.object({
  ownerAddress: f.string(),
  signature: f.object({
    r: f.string(),
    s: f.string()
  }),
  implClassHash: f.string().optional(),
  name: f.string().optional(),
  icon: f.string().optional()
});
function Rl(t) {
  return "transactionVersion" in t;
}
function $l(t) {
  return "simulateTransaction" in t;
}
function Fl(t) {
  return !("simulateTransaction" in t);
}
const Is = f.object({
  value: f.string(),
  platform: f.enum(["ios", "argentx", "android", "webwallet"]).nullable()
}), Ul = f.object({
  preferences: f.record(Is)
}), Ts = f.enum(["mainnet-alpha", "sepolia-alpha"]), Bs = f.enum(["mainnet", "sepolia"]);
function jl(t) {
  return Ts.safeParse(t).success;
}
function Ll(t) {
  return Bs.safeParse(t).success;
}
const Vt = 18;
function Mt({ value: t, decimals: e }) {
  if (e === 0)
    return t.toString();
  const n = t < 0n;
  t = n ? -t : t;
  const r = t.toString().padStart(e, "0"), s = r.slice(0, -e) || "0", o = r.slice(-e).replace(/0+$/, "");
  return `${n ? "-" : ""}${s}${o ? `.${o}` : ""}`;
}
const Ue = (t, e) => ({
  decimals: e,
  value: e >= t.decimals ? t.value * BigInt(10) ** BigInt(e - t.decimals) : t.value / BigInt(10) ** BigInt(t.decimals - e)
}), Xn = (t) => {
  const e = t.value.toString().split("").reverse();
  let n = 0;
  for (let s = 0; s < e.length && e[s] === "0"; s++)
    n++;
  const r = t.decimals - n;
  return Ue(t, r);
}, Jn = (t, e) => {
  const n = Math.max(t.decimals, e.decimals), [r, s] = [t, e].map((o) => Ue(o, n));
  return [r.value, s.value, n];
}, ie = (t) => (e, n) => {
  const [r, s, o] = Jn(e, n);
  return {
    decimals: o,
    value: t(r, s, o)
  };
}, Gt = (t) => (e, n) => {
  const [r, s] = Jn(e, n);
  return t(r, s);
}, _s = ie((t, e) => t + e), Ns = ie((t, e) => t - e), Cs = ie((t, e, n) => {
  if (e === BigInt(0))
    throw new Error("Division by zero is not allowed");
  return t * BigInt(10) ** BigInt(n) / e;
}), Os = (t, e) => Xn({
  decimals: t.decimals + e.decimals,
  value: t.value * e.value
}), ks = ie((t, e) => {
  if (e === BigInt(0))
    throw new Error("Modulus by zero is not allowed");
  return t % e;
}), je = (t) => ({
  decimals: t.decimals,
  value: t.value >= BigInt(0) ? t.value : -t.value
}), Qn = Gt((t, e) => t === e), Ps = Gt((t, e) => t < e), Rs = Gt((t, e) => t > e), $s = Gt((t, e) => t <= e), Fs = Gt((t, e) => t >= e), Us = (t, e) => !Qn(t, e);
function js(t) {
  return Mt({ value: t, decimals: Vt });
}
function Ls(t) {
  return xt(t, Vt);
}
function Ds(t) {
  return Mt({ value: t, decimals: Vt });
}
function Le(t) {
  return xt(t, Vt);
}
function Hs(t) {
  return je({ value: t, decimals: 0 }).value;
}
function Vs(t) {
  return je(Le(t));
}
function Ms(t, e) {
  return {
    value: BigInt(t),
    decimals: e
  };
}
const Gs = { value: 1n, decimals: 0 };
function zs(t) {
  return f.string().refine((e) => /^-?\d+(\.\d+)?$/.test(e), { message: "Invalid number format" }).transform((e) => xt(e, t));
}
const Dl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ONE: Gs,
  abs: je,
  absBigInt: Hs,
  add: _s,
  createUnitsSchema: zs,
  div: Cs,
  eq: Qn,
  formatCurrency: Ds,
  formatEther: js,
  formatUnits: Mt,
  gt: Rs,
  gte: Fs,
  lt: Ps,
  lte: $s,
  mod: ks,
  mul: Os,
  not: Us,
  parseCurrency: Le,
  parseCurrencyAbs: Vs,
  parseEther: Ls,
  parseUnits: xt,
  sub: Ns,
  toBigDecimal: Ms,
  toFixedDecimals: Ue,
  toTiniestPossibleDecimal: Xn
}, Symbol.toStringTag, { value: "Module" }));
class Hl {
  constructor(e, n) {
    this.cachePromise = n.open(e).catch((r) => (console.error(new Error("Failed to open cache", { cause: r })), null));
  }
  async get(e) {
    const n = await this.cachePromise;
    if (!n)
      throw new Error("No cache available");
    const r = await n.match(e).catch(() => {
      throw new Error("Failed to match cache");
    });
    if (!r)
      throw new Error("Failed to match cache");
    return r.clone();
  }
  async set(e, n) {
    const r = await this.cachePromise;
    r && await r.put(e, n).catch(() => {
      throw new Error("Failed to match cache");
    });
  }
  async delete(e) {
    const n = await this.cachePromise;
    return n ? n.delete(e) : !1;
  }
  // should be called on logout
  async flush() {
    const e = await this.cachePromise;
    if (!e)
      return;
    const n = await e.keys();
    await Promise.allSettled(n.map((r) => e.delete(r)));
  }
}
class Vl {
  constructor(e, n) {
    this.httpService = e, this.baseUrl = n, this.offsetInS = 0, this.syncIntervalInMs = 60 * 1e3, this.initialSync = this.syncWithServer(), setInterval(() => void this.syncWithServer(), this.syncIntervalInMs);
  }
  async now() {
    return await this.initialSync, new Date(Date.now() + this.offsetInS * 1e3);
  }
  async syncWithServer() {
    if (typeof window > "u")
      return;
    const { time: e } = await this.httpService.get(`${this.baseUrl}/time`), n = Math.floor(Date.now() / 1e3), r = e - n;
    this.offsetInS = r;
  }
}
class De {
  constructor(e, n = "json") {
    this.requestInit = e, this.responseType = n;
  }
  async get(e, n) {
    const r = qt(this.requestInit) ? await this.requestInit() : this.requestInit, s = {
      ...r,
      ...n,
      method: "GET",
      // merge headers
      headers: {
        ...r == null ? void 0 : r.headers,
        ...n == null ? void 0 : n.headers
      }
    }, o = await fetch(e, s).catch(() => {
      throw new K(en.FAILED_TO_FETCH_URL, 0);
    });
    if (this.responseType === "json") {
      if (!o.ok)
        throw new K(o.statusText, o.status);
      return await o.json();
    }
    return o;
  }
  async post(e, n, r) {
    const s = qt(this.requestInit) ? await this.requestInit() : this.requestInit, o = {
      ...s,
      ...n,
      method: "POST",
      // merge headers
      headers: {
        ...s == null ? void 0 : s.headers,
        ...n == null ? void 0 : n.headers
      }
    }, a = await fetch(e, o).catch(() => {
      throw new K(en.FAILED_TO_POST_URL, 0);
    });
    if (!a.ok)
      throw new K(a.statusText, a.status, await a.json());
    if (a.status === 204)
      return {};
    const i = await a.json();
    if (r)
      try {
        return r.parse(i);
      } catch (c) {
        throw new K(c.message, 0);
      }
    return i;
  }
  async put(e, n) {
    const r = qt(this.requestInit) ? await this.requestInit() : this.requestInit, s = {
      ...r,
      ...n,
      method: "PUT",
      // merge headers
      headers: {
        ...r == null ? void 0 : r.headers,
        ...n == null ? void 0 : n.headers
      }
    }, o = await fetch(e, s).catch(() => {
      throw new K("Failed to put url", 0);
    });
    if (!o.ok)
      throw new K(o.statusText, o.status);
    return await o.json();
  }
  async delete(e, n) {
    const r = qt(this.requestInit) ? await this.requestInit() : this.requestInit, s = {
      ...r,
      ...n,
      method: "DELETE",
      // merge headers
      headers: {
        ...r == null ? void 0 : r.headers,
        ...n == null ? void 0 : n.headers
      }
    }, o = await fetch(e, s).catch(() => {
      throw new K("Failed to delete url", 0);
    });
    if (!o.ok)
      throw new K(o.statusText, o.status);
  }
}
const Wt = (t) => {
  process.env.NODE_ENV;
};
function qs(t, e) {
  const n = t.clone(), r = new Headers(n.headers);
  for (const [s, o] of Object.entries(e))
    r.set(s, o);
  return new Response(n.body, {
    status: n.status,
    statusText: t.statusText,
    headers: r
  });
}
class Ml {
  constructor(e, n, r, s) {
    this.dateService = e, this.cacheService = n, this.httpService = r, this.options = s, this.inFlightRequests = /* @__PURE__ */ new Map();
  }
  async rawGet(e, n) {
    try {
      const r = await this.cacheService.get(e), s = await this.dateService.now(), o = new Date(r.headers.get("date") || ""), a = s.getTime() - o.getTime();
      if (a < this.options.freshFor)
        return Wt("🟢 [SWR] Using fresh cache"), r;
      if (a < this.options.staleFor)
        return this.fetchAndCache(e, n), Wt("🟠 [SWR] Revalidating cache"), r;
      throw new Error("Cache too old");
    } catch (r) {
      if (r instanceof K)
        throw r;
      return Wt(), await this.fetchAndCache(e, n);
    }
  }
  async get(e, n) {
    const r = await this.rawGet(e, n);
    return this.parseResponse(r);
  }
  async fetchAndCache(e, n) {
    const r = this.inFlightRequests.get(e);
    if (!r) {
      const s = this.httpService.get(e, n).then(async (o) => {
        const a = await this.dateService.now();
        return await this.cacheService.set(e, qs(o, {
          date: a.toUTCString()
        })), o;
      }).finally(() => {
        this.inFlightRequests.delete(e);
      });
      return this.inFlightRequests.set(e, s), s;
    }
    return Wt(), r;
  }
  parseResponse(e) {
    if (e.ok)
      return e.json();
    throw new K(e.statusText, e.status);
  }
}
const Xt = (t, e, n) => {
  const r = new Error(t);
  r.name = "FetcherError", r.url = e.url, r.status = e.status, r.statusText = e.statusText, r.responseText = n;
  try {
    const s = JSON.parse(n);
    r.responseJson = s;
  } catch {
  }
  return r;
}, tr = async (t, e) => {
  const n = await fetch(t, e), r = await n.text();
  if (!n.ok)
    throw Xt("An error occurred while fetching", n, r);
  try {
    return JSON.parse(r);
  } catch {
    throw Xt("An error occurred while parsing", n, r);
  }
}, Gl = async (t, e) => {
  const n = await fetch(t, {
    method: "POST",
    ...e
  }), r = await n.text();
  if (!n.ok)
    throw Xt("An error occurred while fetching", n, r);
  try {
    return JSON.parse(r);
  } catch {
    throw Xt("An error occurred while parsing", n, r);
  }
}, zl = (t) => ({
  refreshInterval: t,
  dedupingInterval: t
}), ql = (t) => `${t.networkId}::${t.address}`, Ws = () => {
};
function Ks(t, e, n, r) {
  const { cache: s } = ws(), o = ae(t && e, t ? n : Ws, r);
  return Ft(() => {
    t || (o.mutate(), s.delete(e));
  }, [t]), o;
}
const Wl = {
  revalidateOnFocus: !1,
  revalidateOnMount: !0,
  revalidateOnReconnect: !1,
  refreshWhenOffline: !1,
  refreshWhenHidden: !1,
  refreshInterval: 0
}, Zs = async (t, e) => {
  try {
    const { time: n } = await tr(k(t, "time"), {
      headers: e
    });
    return n;
  } catch {
    throw new Error("failed to request time");
  }
}, Kl = async (t, e) => {
  const n = await Zs(t, e);
  return Math.floor(n);
};
function Ys(t) {
  switch (t) {
    case "mainnet-alpha":
    case Z.NetworkName.SN_MAIN:
      return Z.StarknetChainId.SN_MAIN;
    case "sepolia-alpha":
    case Z.NetworkName.SN_SEPOLIA:
      return Z.StarknetChainId.SN_SEPOLIA;
    default:
      throw new Ln({
        code: "NOT_FOUND",
        message: `Unknown networkId: ${t}`
      });
  }
}
function Xs(t) {
  return t.replace(".stark", "").split(".").map((r) => Mn.useEncoded(r).toString(10));
}
function Js(t) {
  const e = Ys(t);
  return Mn.getStarknetIdContract(e);
}
function Qs(t, e) {
  const n = Js(e), r = Xs(t);
  try {
    const o = { domain: r, hint: [] };
    return Dr.parse({
      contractAddress: n,
      entrypoint: "domain_to_address",
      calldata: o
    });
  } catch (s) {
    throw new Dn({
      code: "NOT_VALID",
      options: { error: s }
    });
  }
}
async function to(t, e, n) {
  if (!e || !n)
    throw new Ln({
      code: "NO_NETWORK_OR_MULTICALL"
    });
  let r = null;
  try {
    r = Qs(t, e);
  } catch (i) {
    throw new Dn({
      code: "NOT_VALID",
      options: { error: i }
    });
  }
  let s, o;
  try {
    s = await n.callContract(r), o = s[0];
  } catch {
    throw new St({
      code: "STARKNAME_ERROR"
    });
  }
  if (Hr(o))
    throw new St({
      code: "STARKNAME_NOT_FOUND",
      message: `${t} not found`
    });
  if (!Vr(o))
    throw new St({
      code: "STARKNAME_INVALID_ADDRESS",
      message: `${t} resolved to an invalid address (${o})`
    });
  return Hn(o);
}
class Zl {
  constructor(e, n, r) {
    this.httpService = e, this.baseUrl = n, this.allowedArgentNameNetworkId = r;
  }
  async parseAddressOrDomain(e, n, r) {
    if (Mr(e))
      return Hn(e);
    try {
      return await this.getAddressFromDomainName(e, n, r);
    } catch {
      throw new St({ code: "NOT_VALID" });
    }
  }
  async getAddressFromDomainName(e, n, r) {
    if (Gr(e))
      return to(e, n, r);
    if (zr(e)) {
      if (n !== this.allowedArgentNameNetworkId)
        throw new St({
          code: "ARGENT_NAME_INVALID_NETWORK",
          message: `Argent name is only enabled on "${this.allowedArgentNameNetworkId}"`
        });
      return qr(e, this.httpService, this.baseUrl);
    }
    throw new St({
      code: "NO_ADDRESS_FROM_DOMAIN"
    });
  }
}
const eo = [
  "0x25ec026985a3bf9d0cc1fe17326b245dfdc3ff89b8fde106542a3ea56c5a918"
], tt = {
  // CAIRO_0
  // NOTE: 0.2.4 is actually defined as 0.2.3.1 but it's not supported by semver
  "0.2.4": "0x033434ad846cdd5f23eb73ff09fe6fddd568284a0fb7d1be20ee482f044dabe2",
  "0.2.3": "0x1a7820094feaf82d53f53f214b81292d717e7bb9a92bb2488092cd306f3993f",
  "0.2.2": "0x3e327de1c40540b98d05cbcb13552008e36f0ec8d61d46956d2f9752c294328",
  "0.2.1": "0x7e28fb0161d10d1cf7fe1f13e7ca57bce062731a3bd04494dfd2d0412699727",
  // CAIRO_1
  "0.4.0": "0x036078334509b514626504edc9fb252328d1a240e4e948bef8d0c08dff45927f",
  "0.3.1": "0x29927c8af6bccf3f6fda035981e765a7bdbf18a2dc0d630494f8758aa908e2b",
  "0.3.0": "0x1a736d6ed154502257f02b1ccdf4d9d1089f80811cd6acad48e6b6a9d1f2003"
}, Jt = {
  "0.1.1": "0x6e150953b26271a740bf2b6e9bca17cc52c68d765f761295de51ceb8526ee72",
  "0.1.0": "0x737ee2f87ce571a58c6c8da558ec18a07ceb64a6172d5ec46171fbc80077a48"
};
var no = typeof global == "object" && global && global.Object === Object && global, ro = typeof self == "object" && self && self.Object === Object && self, ce = no || ro || Function("return this")(), Qt = ce.Symbol, er = Object.prototype, so = er.hasOwnProperty, oo = er.toString, Nt = Qt ? Qt.toStringTag : void 0;
function ao(t) {
  var e = so.call(t, Nt), n = t[Nt];
  try {
    t[Nt] = void 0;
    var r = !0;
  } catch {
  }
  var s = oo.call(t);
  return r && (e ? t[Nt] = n : delete t[Nt]), s;
}
var io = Object.prototype, co = io.toString;
function lo(t) {
  return co.call(t);
}
var uo = "[object Null]", fo = "[object Undefined]", fn = Qt ? Qt.toStringTag : void 0;
function ho(t) {
  return t == null ? t === void 0 ? fo : uo : fn && fn in Object(t) ? ao(t) : lo(t);
}
function nr(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var po = "[object AsyncFunction]", mo = "[object Function]", go = "[object GeneratorFunction]", wo = "[object Proxy]";
function yo(t) {
  if (!nr(t))
    return !1;
  var e = ho(t);
  return e == mo || e == go || e == po || e == wo;
}
var be = ce["__core-js_shared__"], hn = function() {
  var t = /[^.]+$/.exec(be && be.keys && be.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function bo(t) {
  return !!hn && hn in t;
}
var So = Function.prototype, Eo = So.toString;
function Ao(t) {
  if (t != null) {
    try {
      return Eo.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var xo = /[\\^$.*+?()[\]{}|]/g, vo = /^\[object .+?Constructor\]$/, Io = Function.prototype, To = Object.prototype, Bo = Io.toString, _o = To.hasOwnProperty, No = RegExp(
  "^" + Bo.call(_o).replace(xo, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Co(t) {
  if (!nr(t) || bo(t))
    return !1;
  var e = yo(t) ? No : vo;
  return e.test(Ao(t));
}
function Oo(t, e) {
  return t == null ? void 0 : t[e];
}
function He(t, e) {
  var n = Oo(t, e);
  return Co(n) ? n : void 0;
}
var Ut = He(Object, "create");
function ko() {
  this.__data__ = Ut ? Ut(null) : {}, this.size = 0;
}
function Po(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var Ro = "__lodash_hash_undefined__", $o = Object.prototype, Fo = $o.hasOwnProperty;
function Uo(t) {
  var e = this.__data__;
  if (Ut) {
    var n = e[t];
    return n === Ro ? void 0 : n;
  }
  return Fo.call(e, t) ? e[t] : void 0;
}
var jo = Object.prototype, Lo = jo.hasOwnProperty;
function Do(t) {
  var e = this.__data__;
  return Ut ? e[t] !== void 0 : Lo.call(e, t);
}
var Ho = "__lodash_hash_undefined__";
function Vo(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = Ut && e === void 0 ? Ho : e, this;
}
function ft(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
ft.prototype.clear = ko;
ft.prototype.delete = Po;
ft.prototype.get = Uo;
ft.prototype.has = Do;
ft.prototype.set = Vo;
function Mo() {
  this.__data__ = [], this.size = 0;
}
function Go(t, e) {
  return t === e || t !== t && e !== e;
}
function le(t, e) {
  for (var n = t.length; n--; )
    if (Go(t[n][0], e))
      return n;
  return -1;
}
var zo = Array.prototype, qo = zo.splice;
function Wo(t) {
  var e = this.__data__, n = le(e, t);
  if (n < 0)
    return !1;
  var r = e.length - 1;
  return n == r ? e.pop() : qo.call(e, n, 1), --this.size, !0;
}
function Ko(t) {
  var e = this.__data__, n = le(e, t);
  return n < 0 ? void 0 : e[n][1];
}
function Zo(t) {
  return le(this.__data__, t) > -1;
}
function Yo(t, e) {
  var n = this.__data__, r = le(n, t);
  return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
}
function It(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
It.prototype.clear = Mo;
It.prototype.delete = Wo;
It.prototype.get = Ko;
It.prototype.has = Zo;
It.prototype.set = Yo;
var Xo = He(ce, "Map");
function Jo() {
  this.size = 0, this.__data__ = {
    hash: new ft(),
    map: new (Xo || It)(),
    string: new ft()
  };
}
function Qo(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function ue(t, e) {
  var n = t.__data__;
  return Qo(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
function ta(t) {
  var e = ue(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
function ea(t) {
  return ue(this, t).get(t);
}
function na(t) {
  return ue(this, t).has(t);
}
function ra(t, e) {
  var n = ue(this, t), r = n.size;
  return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
}
function Tt(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
Tt.prototype.clear = Jo;
Tt.prototype.delete = ta;
Tt.prototype.get = ea;
Tt.prototype.has = na;
Tt.prototype.set = ra;
var sa = "__lodash_hash_undefined__";
function oa(t) {
  return this.__data__.set(t, sa), this;
}
function aa(t) {
  return this.__data__.has(t);
}
function te(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.__data__ = new Tt(); ++e < n; )
    this.add(t[e]);
}
te.prototype.add = te.prototype.push = oa;
te.prototype.has = aa;
function ia(t, e, n, r) {
  for (var s = t.length, o = n + -1; ++o < s; )
    if (e(t[o], o, t))
      return o;
  return -1;
}
function ca(t) {
  return t !== t;
}
function la(t, e, n) {
  for (var r = n - 1, s = t.length; ++r < s; )
    if (t[r] === e)
      return r;
  return -1;
}
function ua(t, e, n) {
  return e === e ? la(t, e, n) : ia(t, ca, n);
}
function da(t, e) {
  var n = t == null ? 0 : t.length;
  return !!n && ua(t, e, 0) > -1;
}
function fa(t, e, n) {
  for (var r = -1, s = t == null ? 0 : t.length; ++r < s; )
    if (n(e, t[r]))
      return !0;
  return !1;
}
function ha(t, e) {
  return t.has(e);
}
var Se = He(ce, "Set");
function pa() {
}
function rr(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r) {
    n[++e] = r;
  }), n;
}
var ma = 1 / 0, ga = Se && 1 / rr(new Se([, -0]))[1] == ma ? function(t) {
  return new Se(t);
} : pa, wa = 200;
function ya(t, e, n) {
  var r = -1, s = da, o = t.length, a = !0, i = [], c = i;
  if (n)
    a = !1, s = fa;
  else if (o >= wa) {
    var l = ga(t);
    if (l)
      return rr(l);
    a = !1, s = ha, c = new te();
  } else
    c = i;
  t:
    for (; ++r < o; ) {
      var d = t[r], u = d;
      if (d = n || d !== 0 ? d : 0, a && u === u) {
        for (var y = c.length; y--; )
          if (c[y] === u)
            continue t;
        i.push(d);
      } else s(c, u, n) || (c !== i && c.push(u), i.push(d));
    }
  return i;
}
function ba(t, e) {
  return e = typeof e == "function" ? e : void 0, t && t.length ? ya(t, void 0, e) : [];
}
function pn(t) {
  const e = Object.entries(tt), n = Object.entries(Jt);
  switch (t) {
    case "cairo0":
      return e.filter(([r]) => Q.lt(r, "0.3.0")).map(([, r]) => r);
    case "cairo1":
      return e.filter(([r]) => Q.gte(r, "0.3.0")).map(([, r]) => r);
    case "multisig":
      return n.map(([, r]) => r);
    default:
      return e.map(([, r]) => r);
  }
}
function Sa() {
  const t = Q.maxSatisfying(Object.keys(tt), "*");
  if (!t)
    throw new Error(`No argent account contract found: v${t} `);
  return tt[t];
}
function Yl() {
  const t = Q.maxSatisfying(Object.keys(Jt), "*");
  if (!t)
    throw new Error(`No argent multisig contract found: v${t} `);
  return Jt[t];
}
function Ea() {
  return Object.entries(tt).filter(([t]) => Q.gte(t, "0.4.0")).map(([, t]) => t);
}
function Xl() {
  const t = Q.maxSatisfying(Object.keys(tt), "<0.3.0");
  if (!t)
    throw new Error(`No argent account contract found: v${t} `);
  return tt[t];
}
function Aa() {
  const t = Object.entries(tt).filter(([n]) => Q.gte(n, "0.3.1")).map(([, n]) => n), e = Object.entries(Jt).filter(([n]) => Q.gte(n, "0.1.1")).map(([, n]) => n);
  return [...t, ...e];
}
function Jl() {
  return Object.entries(tt).filter(([t]) => Q.gte(t, "0.4.0")).map(([, t]) => t);
}
function Ql() {
  const t = Q.maxSatisfying(Object.keys(tt), ">=0.4.0");
  if (!t)
    throw new Error(`No ledger account contract found: v${t}`);
  return tt[t];
}
const xa = (t, e) => t.cairoVersion === e.cairoVersion && nt(t.accountClassHash, e.accountClassHash);
function tu(t, e, n = []) {
  if (e.type === "imported")
    throw new Error("Cannot find implementation for imported account");
  const r = nn.parse({
    cairoVersion: e.cairoVersion ?? "1",
    accountClassHash: e.classHash ?? Sa()
  }), s = f.array(nn).parse(n), o = [
    ...pn("cairo0").map((l) => ({ cairoVersion: "0", accountClassHash: l })),
    ...pn("cairo1").map((l) => ({ cairoVersion: "1", accountClassHash: l }))
  ], c = ba([
    r,
    ...s,
    ...o
  ], xa).map((l) => ({
    implementation: l,
    address: Ta(l.cairoVersion, l.accountClassHash, t, e.guardian, e.salt)
  })).find((l) => nt(l.address, e.address));
  if (!c)
    throw new Wr({ code: "CALCULATED_ADDRESS_NO_MATCH" });
  return c.implementation;
}
function va(t, e, n, r, s, o = eo[0]) {
  const a = Ia(t, e, n, r);
  return {
    classHash: t === "0" ? o : e,
    constructorCalldata: mt.compile(a),
    addressSalt: s || n
  };
}
function Ia(t, e, n, r) {
  const s = t !== "0" && nt(Kr, e), o = {
    pubkey: n,
    ...s ? {} : { guardian: r || "0" }
  };
  if (Ea().some((i) => nt(i, e))) {
    const i = rn(n, sn.Starknet), c = r ? new an(cn.Some, rn(r, sn.Starknet)) : new an(cn.None, null);
    return { ownerSigner: i, guardianAsOption: c };
  }
  return t === "0" ? Zr.parse({
    implementation: e,
    selector: Gn.getSelectorFromName("initialize"),
    calldata: mt.compile(o)
  }) : Yr.parse({
    owner: n,
    guardian: r
  });
}
function Ta(t, e, n, r, s) {
  const o = va(t, e, n, r, s);
  return Gn.calculateContractAddressFromHash(o.addressSalt, o.classHash, o.constructorCalldata, 0);
}
function eu(t, e) {
  const n = un(t), r = un();
  return Ft(() => {
    n.current = t;
  }, [t]), Ft(() => () => {
    r.current && clearTimeout(r.current);
  }, []), (...s) => {
    r.current && clearTimeout(r.current), r.current = setTimeout(() => n.current(...s), e);
  };
}
function nu(t, e) {
  const [n, r] = zn(t);
  return Ft(() => {
    const s = setTimeout(() => {
      r(t);
    }, e);
    return () => {
      clearTimeout(s);
    };
  }, [t, e]), n;
}
const Ba = f.object({
  name: f.enum([
    "dappland",
    "discord",
    "github",
    "telegram",
    "twitter",
    "website"
  ]),
  url: f.string(),
  position: f.number()
}), _a = f.object({
  address: Re,
  chain: f.enum(["ethereum", "starknet"])
}), Na = f.object({
  maxExpiryDays: f.number().positive(),
  allowList: f.array(f.object({
    contractAddress: Re,
    methods: f.array(f.string())
  }))
}), Ca = f.object({
  dappId: f.string(),
  name: f.string(),
  description: f.string().optional(),
  logoUrl: f.string().optional(),
  dappUrl: f.string().optional(),
  inAppBrowserCompatible: f.boolean(),
  argentVerified: f.boolean(),
  links: f.array(Ba).optional(),
  contracts: f.array(_a).optional(),
  categories: f.array(f.string()).optional(),
  supportedApps: f.array(f.string()).optional(),
  brandColor: f.string().optional(),
  executeFromOutsideAllowed: f.boolean().default(!1).optional(),
  sessionConfig: Na.optional()
}), Oa = f.array(Ca);
class ru {
  constructor(e, n) {
    this.apiBase = e, this.httpService = new De(n, "json");
  }
  async getAll() {
    const e = await this.httpService.get(`${this.apiBase}/tokens/dapps`), n = Oa.safeParse(e);
    if (!n.success)
      throw new Error("Failed to parse known dapps");
    return n.data;
  }
}
function ka(t) {
  var e;
  return (e = t == null ? void 0 : t.links) == null ? void 0 : e.find((n) => n.name === "dappland");
}
function su(t) {
  var e;
  return (e = ka(t)) == null ? void 0 : e.url;
}
const sr = F.object({
  domain: Xr,
  address: se.optional(),
  avatar: F.string().optional(),
  status: F.union([F.literal("KNOWN"), F.literal("UNKNOWN")])
}), Pa = F.array(sr), Ra = F.object({
  provider: F.string(),
  name: F.string(),
  avatar: F.string().optional()
}), $a = F.object({
  address: se,
  status: F.union([F.literal("KNOWN"), F.literal("UNKNOWN")]),
  resolutions: F.array(Ra).optional()
}), Fa = F.array(F.string()), Ua = $a.array();
class ou {
  constructor(e, n) {
    this.apiBase = e, this.headers = n, this.httpService = new De(this.headers, "json");
  }
  async getAddressFromMultipleStarknetId(e, n, r) {
    const s = new URLSearchParams(n.map((c) => ["domain", c]));
    r && s.set("includeAvatar", "true");
    const o = k(this.apiBase, e, "starknet.id", `?${s}`), a = await this.httpService.get(o), i = Pa.safeParse(a);
    if (!i.success)
      throw new Error("Failed to parse name resolution");
    return i.data;
  }
  async getAddressFromStarknetId(e, n, r) {
    const s = k(this.apiBase, e, "starknet.id", n, r ? "?includeAvatar=true" : ""), o = await this.httpService.get(s), a = sr.safeParse(o);
    if (!a.success)
      throw new Error("Failed to parse name resolution");
    return a.data;
  }
  /**
   * getAddressFromStarknetId: retrieve address from starknetId
   */
  async getStarknetIdFromAddress(e, n, r) {
    const s = new URLSearchParams(n.map((c) => ["address", c]));
    r && s.set("includeAvatar", "true");
    const o = k(this.apiBase, e, "addresses", `?${s}`), a = await this.httpService.get(o), i = Ua.safeParse(a);
    if (!i.success)
      throw new Error("Failed to parse name resolution");
    return i.data;
  }
  async getProvidersNames(e) {
    const n = k(this.apiBase, e, "providers", "name"), r = await this.httpService.get(n), s = Fa.safeParse(r);
    if (!s.success)
      throw new Error("Failed to parse name resolution");
    return s.data;
  }
}
const or = (t) => t.slice(0, 6) + "..." + t.slice(-4);
function mn(t) {
  if (!Number.isSafeInteger(t) || t < 0)
    throw new Error(`positive integer expected, not ${t}`);
}
function ja(t) {
  return t instanceof Uint8Array || t != null && typeof t == "object" && t.constructor.name === "Uint8Array";
}
function de(t, ...e) {
  if (!ja(t))
    throw new Error("Uint8Array expected");
  if (e.length > 0 && !e.includes(t.length))
    throw new Error(`Uint8Array expected of length ${e}, not of length=${t.length}`);
}
function gn(t, e = !0) {
  if (t.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (e && t.finished)
    throw new Error("Hash#digest() has already been called");
}
function La(t, e) {
  de(t);
  const n = e.outputLen;
  if (t.length < n)
    throw new Error(`digestInto() expects output buffer of length at least ${n}`);
}
const Kt = /* @__PURE__ */ BigInt(2 ** 32 - 1), wn = /* @__PURE__ */ BigInt(32);
function Da(t, e = !1) {
  return e ? { h: Number(t & Kt), l: Number(t >> wn & Kt) } : { h: Number(t >> wn & Kt) | 0, l: Number(t & Kt) | 0 };
}
function Ha(t, e = !1) {
  let n = new Uint32Array(t.length), r = new Uint32Array(t.length);
  for (let s = 0; s < t.length; s++) {
    const { h: o, l: a } = Da(t[s], e);
    [n[s], r[s]] = [o, a];
  }
  return [n, r];
}
const Va = (t, e, n) => t << n | e >>> 32 - n, Ma = (t, e, n) => e << n | t >>> 32 - n, Ga = (t, e, n) => e << n - 32 | t >>> 64 - n, za = (t, e, n) => t << n - 32 | e >>> 64 - n;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const qa = (t) => new Uint32Array(t.buffer, t.byteOffset, Math.floor(t.byteLength / 4)), yn = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68, Wa = (t) => t << 24 & 4278190080 | t << 8 & 16711680 | t >>> 8 & 65280 | t >>> 24 & 255;
function bn(t) {
  for (let e = 0; e < t.length; e++)
    t[e] = Wa(t[e]);
}
const Ka = /* @__PURE__ */ Array.from({ length: 256 }, (t, e) => e.toString(16).padStart(2, "0"));
function Za(t) {
  de(t);
  let e = "";
  for (let n = 0; n < t.length; n++)
    e += Ka[t[n]];
  return e;
}
function ar(t) {
  if (typeof t != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof t}`);
  return new Uint8Array(new TextEncoder().encode(t));
}
function ir(t) {
  return typeof t == "string" && (t = ar(t)), de(t), t;
}
let Ya = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function Xa(t) {
  const e = (r) => t().update(ir(r)).digest(), n = t();
  return e.outputLen = n.outputLen, e.blockLen = n.blockLen, e.create = () => t(), e;
}
const cr = [], lr = [], ur = [], Ja = /* @__PURE__ */ BigInt(0), Ct = /* @__PURE__ */ BigInt(1), Qa = /* @__PURE__ */ BigInt(2), ti = /* @__PURE__ */ BigInt(7), ei = /* @__PURE__ */ BigInt(256), ni = /* @__PURE__ */ BigInt(113);
for (let t = 0, e = Ct, n = 1, r = 0; t < 24; t++) {
  [n, r] = [r, (2 * n + 3 * r) % 5], cr.push(2 * (5 * r + n)), lr.push((t + 1) * (t + 2) / 2 % 64);
  let s = Ja;
  for (let o = 0; o < 7; o++)
    e = (e << Ct ^ (e >> ti) * ni) % ei, e & Qa && (s ^= Ct << (Ct << /* @__PURE__ */ BigInt(o)) - Ct);
  ur.push(s);
}
const [ri, si] = /* @__PURE__ */ Ha(ur, !0), Sn = (t, e, n) => n > 32 ? Ga(t, e, n) : Va(t, e, n), En = (t, e, n) => n > 32 ? za(t, e, n) : Ma(t, e, n);
function oi(t, e = 24) {
  const n = new Uint32Array(10);
  for (let r = 24 - e; r < 24; r++) {
    for (let a = 0; a < 10; a++)
      n[a] = t[a] ^ t[a + 10] ^ t[a + 20] ^ t[a + 30] ^ t[a + 40];
    for (let a = 0; a < 10; a += 2) {
      const i = (a + 8) % 10, c = (a + 2) % 10, l = n[c], d = n[c + 1], u = Sn(l, d, 1) ^ n[i], y = En(l, d, 1) ^ n[i + 1];
      for (let m = 0; m < 50; m += 10)
        t[a + m] ^= u, t[a + m + 1] ^= y;
    }
    let s = t[2], o = t[3];
    for (let a = 0; a < 24; a++) {
      const i = lr[a], c = Sn(s, o, i), l = En(s, o, i), d = cr[a];
      s = t[d], o = t[d + 1], t[d] = c, t[d + 1] = l;
    }
    for (let a = 0; a < 50; a += 10) {
      for (let i = 0; i < 10; i++)
        n[i] = t[a + i];
      for (let i = 0; i < 10; i++)
        t[a + i] ^= ~n[(i + 2) % 10] & n[(i + 4) % 10];
    }
    t[0] ^= ri[r], t[1] ^= si[r];
  }
  n.fill(0);
}
let ai = class dr extends Ya {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(e, n, r, s = !1, o = 24) {
    if (super(), this.blockLen = e, this.suffix = n, this.outputLen = r, this.enableXOF = s, this.rounds = o, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, mn(r), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = qa(this.state);
  }
  keccak() {
    yn || bn(this.state32), oi(this.state32, this.rounds), yn || bn(this.state32), this.posOut = 0, this.pos = 0;
  }
  update(e) {
    gn(this);
    const { blockLen: n, state: r } = this;
    e = ir(e);
    const s = e.length;
    for (let o = 0; o < s; ) {
      const a = Math.min(n - this.pos, s - o);
      for (let i = 0; i < a; i++)
        r[this.pos++] ^= e[o++];
      this.pos === n && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: e, suffix: n, pos: r, blockLen: s } = this;
    e[r] ^= n, n & 128 && r === s - 1 && this.keccak(), e[s - 1] ^= 128, this.keccak();
  }
  writeInto(e) {
    gn(this, !1), de(e), this.finish();
    const n = this.state, { blockLen: r } = this;
    for (let s = 0, o = e.length; s < o; ) {
      this.posOut >= r && this.keccak();
      const a = Math.min(r - this.posOut, o - s);
      e.set(n.subarray(this.posOut, this.posOut + a), s), this.posOut += a, s += a;
    }
    return e;
  }
  xofInto(e) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(e);
  }
  xof(e) {
    return mn(e), this.xofInto(new Uint8Array(e));
  }
  digestInto(e) {
    if (La(e, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(e), this.destroy(), e;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(e) {
    const { blockLen: n, suffix: r, outputLen: s, rounds: o, enableXOF: a } = this;
    return e || (e = new dr(n, r, s, a, o)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = o, e.suffix = r, e.outputLen = s, e.enableXOF = a, e.destroyed = this.destroyed, e;
  }
};
const ii = (t, e, n) => Xa(() => new ai(e, t, n)), ci = /* @__PURE__ */ ii(1, 136, 256 / 8);
function li(t) {
  return `0x${Za(ci(ar(t)))}`;
}
const ui = (t) => {
  if (!Wn(t))
    return;
  const e = /(\d+)$/, n = t.match(e);
  if (n)
    return n[1];
}, di = (t, e = !1) => {
  if (!Wn(t))
    return "";
  const n = e ? t.replace(/[^0-9a-z ]/gi, "") : t, s = Fe(n).split(" "), o = ui(n), a = s.map((i) => i[0]);
  return o && o.length > 1 && o.length < n.length ? [a[0], o.substring(0, 2)].join("") : s.length === 1 ? s[0].substring(0, 2) : [a[0], a[a.length - 1]].join("");
}, { toBigInt: fi } = O, An = (t) => {
  const e = t.replace("#", "");
  if (!/^[0-9A-F]{6}$/i.test(e))
    throw new Error(`Invalid color ${t}`);
  return `#${e}`;
}, ee = (t, e) => {
  const n = An(e.background), r = An(e.color ?? "#ffffff"), s = di(t, !0), o = `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
    <rect width="48" height="48" fill="${n}" />
    <text x="50%" y="54%" dominant-baseline="middle" text-anchor="middle" font-size="16" font-family="Barlow, Helvetica, Arial, sans-serif" fill="${r}">${s}</text>
  </svg>`;
  return `data:image/svg+xml;base64,${btoa(o)}`;
}, xn = [
  "02BBA8",
  "29C5FF",
  "0078A4",
  "FFBF3D",
  "FFA85C",
  "FF875B",
  "FF675C",
  "FF5C72"
], hi = (t) => {
  const e = li(t).slice(-2), n = parseInt(e, 16) % xn.length;
  return xn[n];
}, pi = (t) => {
  try {
    return O.toHex(fi(O.hexToDecimalString(t)));
  } catch {
  }
  return "";
}, iu = ({ accountName: t, networkId: e, accountAddress: n, backgroundColor: r }) => {
  const s = pi(n), o = `${e}::${s}`, a = r || hi(o);
  return ee(t, { background: a });
}, mi = (t) => {
  const e = $t.removeHexPrefix($t.sanitizeHex(O.toHex(t))), n = Zn.decode(e);
  return Yn.encode(n);
}, cu = (t) => t.map(mi), gi = (t) => {
  const e = Yn.decode(t);
  return $t.sanitizeHex(Zn.encode(e));
}, lu = (t) => t.map(gi);
function uu(t, e) {
  const n = t.getTime(), r = e.getTime(), s = Math.abs(n - r);
  return Math.floor(s / (1e3 * 60 * 60 * 24));
}
const du = (t) => (t || "false") === "true", fu = async (t, e) => {
  try {
    return await t.getClassHashAt(e), !0;
  } catch {
    return !1;
  }
};
function hu(t) {
  return !hs(t);
}
const pu = (t) => {
  const e = /^(0|0x([a-f0-9A-F]+)?)$/;
  return !!(t === "" || e.test(t));
}, Y = (t) => !isNaN(parseFloat(t)) && isFinite(Number(t)), mu = (t, e = 16) => {
  const n = new RegExp(`^[0-9]*.?[0-9]{0,${e}}$`);
  return t === "" ? !0 : Y(t) ? !!n.test(t) : !1;
}, Ve = {
  CURRENCY: {
    minDecimalPlaces: 2,
    maxDecimalPlaces: 10,
    minDecimalSignificantDigits: 2,
    decimalPlacesWhenZero: 2,
    allowLeadingZerosInDecimalPart: !0
  },
  TOKEN: {
    minDecimalPlaces: 4,
    maxDecimalPlaces: 16,
    minDecimalSignificantDigits: 2,
    decimalPlacesWhenZero: 1,
    allowLeadingZerosInDecimalPart: !0
  }
}, wi = (t, e) => fr(t, {
  ...Ve.CURRENCY,
  ...e || {}
}), yi = (t, e) => fr(t, {
  ...Ve.TOKEN,
  ...e || {}
}), fr = (t, { minDecimalPlaces: e, maxDecimalPlaces: n, minDecimalSignificantDigits: r, decimalPlacesWhenZero: s, allowLeadingZerosInDecimalPart: o } = Ve.CURRENCY) => {
  if (!Y(t))
    return null;
  const a = new on(typeof t == "bigint" ? t.toString() : t);
  let i;
  const c = `0.${"".padStart(s - 1, "0")}1`;
  if (a.lt(new on(c)) && !o)
    i = `0.${"".padStart(s, "0")}`;
  else if (a.gte(1))
    i = a.toFormat(e);
  else {
    const m = a.toFormat(n).split(".")[1].match(/^0+/), S = o && m && m.length ? m[0].length : 0, h = Math.max(S + r, e);
    i = a.toFormat(h);
  }
  let l = i.replace(/0+$/, "");
  const d = 1 + i.indexOf(".") + s;
  return l.length < d && (l = i.substring(0, d)), l;
}, bi = (t, e = 18) => {
  const n = t.replace(",", ".");
  return !t || !Y(n) ? 0n : xt(n, Number(e)).value;
};
function jt(t) {
  return Ht.bnToUint256(t);
}
const gu = (t, e) => `${t} ${e}${t === 1 ? "" : "s"}`, wu = (t) => new Promise((e, n) => {
  const r = new FileReader();
  r.onload = () => {
    var s;
    return r.result ? e((s = r.result) == null ? void 0 : s.toString()) : n(new Error("Could not read file"));
  }, r.onerror = n, r.onabort = n.bind(null, new Error("User aborted")), r.readAsText(t);
});
function yu(t) {
  try {
    return ps(Kn(t));
  } catch {
    return t;
  }
}
const Si = (t, e) => {
  const n = new URLSearchParams(e), r = n.size ? `?${n}` : "";
  return k(...oe(t), r);
};
function bu(t) {
  return (...e) => {
    t(...e);
  };
}
class Ei extends Error {
  constructor(e, n) {
    super(`${e}::${n}`), this.name = e, this.code = n, this.name = e;
  }
}
class vn extends Ei {
  constructor(e) {
    super("BackendPaginationError", e);
  }
}
const In = 32;
class Su {
  constructor(e, n, r) {
    this.apiBase = e, this.headers = n, this.imageOptimizationUrl = r, this.httpService = new De(this.headers, "json");
  }
  async getNfts(e, n, r, s = 1) {
    const o = this.normalizeAddress(r), a = k(this.apiBase, "pandora", e, n), i = this.pageToPageIndex(s), l = `${k(a, "profile", o, "nfts")}?page=${i}&size=${In}`, d = await this.httpService.get(l), u = d.content.map((y) => this.mapItem(y, r));
    return {
      totalPages: d.totalPages,
      page: d.number + 1,
      count: u.length,
      nfts: u
    };
  }
  async getCollection(e, n, r) {
    const s = this.normalizeAddress(r), o = k(this.apiBase, "pandora", e, n), a = k(o, "collection", s), i = `${o}/collection/${s}`, [c, l] = await Promise.all([
      this.httpService.get(a),
      this.httpService.get(i)
    ]), d = Ee(c), u = l.content.map((y) => this.mapItem(y));
    return {
      ...d,
      nfts: {
        totalPages: l.totalPages,
        page: l.number,
        count: u.length,
        data: u
      }
    };
  }
  async getNft(e, n, r, s) {
    const o = this.normalizeAddress(r), a = k(this.apiBase, "pandora", e, n), i = k(a, "nft", o, s), c = await this.httpService.get(i);
    return this.mapItem(c);
  }
  async getProfileCollections(e, n, r, s = 1, o = !1) {
    const a = this.pageToPageIndex(s), i = this.normalizeAddress(r), c = k(this.apiBase, "pandora", e, n), l = k(c, "profile", i, "collections", `?page=${a}&size=${In}`), d = await this.httpService.get(l), u = [];
    for (const y of d.content)
      if (o) {
        const m = await this.getCollectionMetrics(e, n, y.contractAddress);
        u.push(Ee(y, m));
      } else
        u.push(Ee(y));
    return {
      totalPages: d.totalPages,
      page: d.number + 1,
      count: u.length,
      collections: u
    };
  }
  async getCollectionMetrics(e, n, r) {
    const s = this.normalizeAddress(r), o = k(this.apiBase, "pandora", e, n), a = k(o, "collection", s, "metrics");
    return this.httpService.get(a);
  }
  normalizeAddress(e) {
    return Re.parse(e);
  }
  pageToPageIndex(e) {
    if (!Number.isInteger(e))
      throw new vn("notANumber");
    const n = e - 1;
    if (n < 0)
      throw new vn("tooLow");
    return n;
  }
  optimizeImage(e, n, r) {
    if (!e)
      return;
    const s = new URLSearchParams({
      url: e,
      w: (n ?? 400).toString(),
      h: (r ?? 400).toString()
    });
    return `${this.imageOptimizationUrl}?${s.toString()}`;
  }
  mapItem(e, n) {
    var s;
    const r = e.name ?? e.tokenId;
    return {
      token_id: e.tokenId,
      contract_address: e.contractAddress,
      name: r,
      spec: "spec" in e ? Ai(e.spec) : void 0,
      description: "",
      best_bid_order: {
        payment_amount: "bestListPrice" in e ? BigInt(e.bestListPrice) : void 0
      },
      properties: "properties" in e && e.properties.map((o) => ({ key: o.key, value: o.value })) || [],
      image_uri: this.optimizeImage(e.imageUrls.preview) ?? ee(r, {
        background: "#15192A",
        color: "#ffffff"
      }),
      image_url_copy: this.optimizeImage(e.imageUrls.full) ?? ee(r, {
        background: "#15192A",
        color: "#ffffff"
      }),
      owner: {
        account_address: ((s = e.owner) == null ? void 0 : s.address) || n
      },
      contract_name: or(e.contractAddress)
    };
  }
}
function Ai(t) {
  switch (t) {
    case "erc721":
    case "starknetErc721":
      return "ERC721";
    case "erc1155":
    case "starknetErc1155":
      return "ERC1155";
  }
}
function Ee(t, e) {
  return {
    contractAddress: se.parse(t.contractAddress),
    name: t.name || or(t.contractAddress),
    description: t.description ?? "",
    imageUri: t.imageUrls.preview ?? ee(t.name || t.contractAddress.replace("0x", ""), {
      background: "#15192A",
      color: "#ffffff"
    }),
    ...e && {
      owners: {
        total: e.numberOfItems,
        unique: e.uniqueOwners
      },
      ...e.floorPrice && {
        //floorPrice: getEthTokenPrice(BigInt(metrics.floorPrice)),
        floorPrice: BigInt(e.floorPrice)
      }
    }
  };
}
const hr = async (t, e, n, r, s = 1) => {
  const o = await t.getNfts(e, n, r, s);
  if (s < o.totalPages) {
    const a = await hr(t, e, n, r, o.page + 1);
    return {
      ...o,
      nfts: o.nfts.concat(a.nfts)
    };
  }
  return o;
}, Eu = (t, e, n, r, s) => {
  const { data: o, ...a } = ae(r && [r, "nfts"], () => r && hr(t, e, n, r), {
    refreshInterval: 3e5,
    ...s
  });
  return { nfts: o == null ? void 0 : o.nfts, ...a };
}, Au = (t, e, n, r, s) => {
  const { data: o, ...a } = ae(r && [`${r}`, "nfts-collection"], () => r && t.getCollection(e, n, r), {
    refreshInterval: 6e4,
    ...s
  });
  return { collection: o, ...a };
}, xu = (t, e, n, r, s, o) => {
  const { data: a, ...i } = ae(s && r && [`${r}:${s}`, "nft"], () => s && r ? t.getNft(e, n, r, s) : void 0, {
    refreshInterval: 6e4,
    revalidateOnFocus: !1,
    revalidateOnMount: !1,
    ...o
  });
  return { nft: a, ...i };
}, vu = ({ image_uri: t, image_url_copy: e }) => {
  if (t && e) {
    if (!e.startsWith("ipfs://"))
      return e;
    if (!t.startsWith("ipfs://"))
      return t;
  }
  return e || t;
}, Iu = (t, e) => t.token_id === e.token_id && nt(t.contract_address, e.contract_address);
function Tn(t) {
  if (!Number.isSafeInteger(t) || t < 0)
    throw new Error(`Wrong positive integer: ${t}`);
}
function xi(t) {
  return t instanceof Uint8Array || t != null && typeof t == "object" && t.constructor.name === "Uint8Array";
}
function pr(t, ...e) {
  if (!xi(t))
    throw new Error("Expected Uint8Array");
  if (e.length > 0 && !e.includes(t.length))
    throw new Error(`Expected Uint8Array of length ${e}, not of length=${t.length}`);
}
function ne(t, e = !0) {
  if (t.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (e && t.finished)
    throw new Error("Hash#digest() has already been called");
}
function mr(t, e) {
  pr(t);
  const n = e.outputLen;
  if (t.length < n)
    throw new Error(`digestInto() expects output buffer of length at least ${n}`);
}
const Zt = /* @__PURE__ */ BigInt(2 ** 32 - 1), Bn = /* @__PURE__ */ BigInt(32);
function vi(t, e = !1) {
  return e ? { h: Number(t & Zt), l: Number(t >> Bn & Zt) } : { h: Number(t >> Bn & Zt) | 0, l: Number(t & Zt) | 0 };
}
function Ii(t, e = !1) {
  let n = new Uint32Array(t.length), r = new Uint32Array(t.length);
  for (let s = 0; s < t.length; s++) {
    const { h: o, l: a } = vi(t[s], e);
    [n[s], r[s]] = [o, a];
  }
  return [n, r];
}
const Ti = (t, e, n) => t << n | e >>> 32 - n, Bi = (t, e, n) => e << n | t >>> 32 - n, _i = (t, e, n) => e << n - 32 | t >>> 64 - n, Ni = (t, e, n) => t << n - 32 | e >>> 64 - n;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Ci = (t) => new Uint32Array(t.buffer, t.byteOffset, Math.floor(t.byteLength / 4));
function Oi(t) {
  return t instanceof Uint8Array || t != null && typeof t == "object" && t.constructor.name === "Uint8Array";
}
const Ae = (t) => new DataView(t.buffer, t.byteOffset, t.byteLength), J = (t, e) => t << 32 - e | t >>> e, ki = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!ki)
  throw new Error("Non little-endian hardware is not supported");
function gr(t) {
  if (typeof t != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof t}`);
  return new Uint8Array(new TextEncoder().encode(t));
}
function Me(t) {
  if (typeof t == "string" && (t = gr(t)), !Oi(t))
    throw new Error(`expected Uint8Array, got ${typeof t}`);
  return t;
}
let wr = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
function yr(t) {
  const e = (r) => t().update(Me(r)).digest(), n = t();
  return e.outputLen = n.outputLen, e.blockLen = n.blockLen, e.create = () => t(), e;
}
const [br, Sr, Er] = [[], [], []], Pi = /* @__PURE__ */ BigInt(0), Ot = /* @__PURE__ */ BigInt(1), Ri = /* @__PURE__ */ BigInt(2), $i = /* @__PURE__ */ BigInt(7), Fi = /* @__PURE__ */ BigInt(256), Ui = /* @__PURE__ */ BigInt(113);
for (let t = 0, e = Ot, n = 1, r = 0; t < 24; t++) {
  [n, r] = [r, (2 * n + 3 * r) % 5], br.push(2 * (5 * r + n)), Sr.push((t + 1) * (t + 2) / 2 % 64);
  let s = Pi;
  for (let o = 0; o < 7; o++)
    e = (e << Ot ^ (e >> $i) * Ui) % Fi, e & Ri && (s ^= Ot << (Ot << /* @__PURE__ */ BigInt(o)) - Ot);
  Er.push(s);
}
const [ji, Li] = /* @__PURE__ */ Ii(Er, !0), _n = (t, e, n) => n > 32 ? _i(t, e, n) : Ti(t, e, n), Nn = (t, e, n) => n > 32 ? Ni(t, e, n) : Bi(t, e, n);
function Di(t, e = 24) {
  const n = new Uint32Array(10);
  for (let r = 24 - e; r < 24; r++) {
    for (let a = 0; a < 10; a++)
      n[a] = t[a] ^ t[a + 10] ^ t[a + 20] ^ t[a + 30] ^ t[a + 40];
    for (let a = 0; a < 10; a += 2) {
      const i = (a + 8) % 10, c = (a + 2) % 10, l = n[c], d = n[c + 1], u = _n(l, d, 1) ^ n[i], y = Nn(l, d, 1) ^ n[i + 1];
      for (let m = 0; m < 50; m += 10)
        t[a + m] ^= u, t[a + m + 1] ^= y;
    }
    let s = t[2], o = t[3];
    for (let a = 0; a < 24; a++) {
      const i = Sr[a], c = _n(s, o, i), l = Nn(s, o, i), d = br[a];
      s = t[d], o = t[d + 1], t[d] = c, t[d + 1] = l;
    }
    for (let a = 0; a < 50; a += 10) {
      for (let i = 0; i < 10; i++)
        n[i] = t[a + i];
      for (let i = 0; i < 10; i++)
        t[a + i] ^= ~n[(i + 2) % 10] & n[(i + 4) % 10];
    }
    t[0] ^= ji[r], t[1] ^= Li[r];
  }
  n.fill(0);
}
class Ge extends wr {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(e, n, r, s = !1, o = 24) {
    if (super(), this.blockLen = e, this.suffix = n, this.outputLen = r, this.enableXOF = s, this.rounds = o, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, Tn(r), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = Ci(this.state);
  }
  keccak() {
    Di(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
  }
  update(e) {
    ne(this);
    const { blockLen: n, state: r } = this;
    e = Me(e);
    const s = e.length;
    for (let o = 0; o < s; ) {
      const a = Math.min(n - this.pos, s - o);
      for (let i = 0; i < a; i++)
        r[this.pos++] ^= e[o++];
      this.pos === n && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: e, suffix: n, pos: r, blockLen: s } = this;
    e[r] ^= n, n & 128 && r === s - 1 && this.keccak(), e[s - 1] ^= 128, this.keccak();
  }
  writeInto(e) {
    ne(this, !1), pr(e), this.finish();
    const n = this.state, { blockLen: r } = this;
    for (let s = 0, o = e.length; s < o; ) {
      this.posOut >= r && this.keccak();
      const a = Math.min(r - this.posOut, o - s);
      e.set(n.subarray(this.posOut, this.posOut + a), s), this.posOut += a, s += a;
    }
    return e;
  }
  xofInto(e) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(e);
  }
  xof(e) {
    return Tn(e), this.xofInto(new Uint8Array(e));
  }
  digestInto(e) {
    if (mr(e, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(e), this.destroy(), e;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(e) {
    const { blockLen: n, suffix: r, outputLen: s, rounds: o, enableXOF: a } = this;
    return e || (e = new Ge(n, r, s, a, o)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = o, e.suffix = r, e.outputLen = s, e.enableXOF = a, e.destroyed = this.destroyed, e;
  }
}
const Hi = (t, e, n) => yr(() => new Ge(e, t, n)), Vi = /* @__PURE__ */ Hi(1, 136, 256 / 8);
function Mi(t, e, n, r) {
  if (typeof t.setBigUint64 == "function")
    return t.setBigUint64(e, n, r);
  const s = BigInt(32), o = BigInt(4294967295), a = Number(n >> s & o), i = Number(n & o), c = r ? 4 : 0, l = r ? 0 : 4;
  t.setUint32(e + c, a, r), t.setUint32(e + l, i, r);
}
class Gi extends wr {
  constructor(e, n, r, s) {
    super(), this.blockLen = e, this.outputLen = n, this.padOffset = r, this.isLE = s, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(e), this.view = Ae(this.buffer);
  }
  update(e) {
    ne(this);
    const { view: n, buffer: r, blockLen: s } = this;
    e = Me(e);
    const o = e.length;
    for (let a = 0; a < o; ) {
      const i = Math.min(s - this.pos, o - a);
      if (i === s) {
        const c = Ae(e);
        for (; s <= o - a; a += s)
          this.process(c, a);
        continue;
      }
      r.set(e.subarray(a, a + i), this.pos), this.pos += i, a += i, this.pos === s && (this.process(n, 0), this.pos = 0);
    }
    return this.length += e.length, this.roundClean(), this;
  }
  digestInto(e) {
    ne(this), mr(e, this), this.finished = !0;
    const { buffer: n, view: r, blockLen: s, isLE: o } = this;
    let { pos: a } = this;
    n[a++] = 128, this.buffer.subarray(a).fill(0), this.padOffset > s - a && (this.process(r, 0), a = 0);
    for (let u = a; u < s; u++)
      n[u] = 0;
    Mi(r, s - 8, BigInt(this.length * 8), o), this.process(r, 0);
    const i = Ae(e), c = this.outputLen;
    if (c % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const l = c / 4, d = this.get();
    if (l > d.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let u = 0; u < l; u++)
      i.setUint32(4 * u, d[u], o);
  }
  digest() {
    const { buffer: e, outputLen: n } = this;
    this.digestInto(e);
    const r = e.slice(0, n);
    return this.destroy(), r;
  }
  _cloneInto(e) {
    e || (e = new this.constructor()), e.set(...this.get());
    const { blockLen: n, buffer: r, length: s, finished: o, destroyed: a, pos: i } = this;
    return e.length = s, e.pos = i, e.finished = o, e.destroyed = a, s % n && e.buffer.set(r), e;
  }
}
const zi = (t, e, n) => t & e ^ ~t & n, qi = (t, e, n) => t & e ^ t & n ^ e & n, Wi = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), it = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), ct = /* @__PURE__ */ new Uint32Array(64);
class Ki extends Gi {
  constructor() {
    super(64, 32, 8, !1), this.A = it[0] | 0, this.B = it[1] | 0, this.C = it[2] | 0, this.D = it[3] | 0, this.E = it[4] | 0, this.F = it[5] | 0, this.G = it[6] | 0, this.H = it[7] | 0;
  }
  get() {
    const { A: e, B: n, C: r, D: s, E: o, F: a, G: i, H: c } = this;
    return [e, n, r, s, o, a, i, c];
  }
  // prettier-ignore
  set(e, n, r, s, o, a, i, c) {
    this.A = e | 0, this.B = n | 0, this.C = r | 0, this.D = s | 0, this.E = o | 0, this.F = a | 0, this.G = i | 0, this.H = c | 0;
  }
  process(e, n) {
    for (let u = 0; u < 16; u++, n += 4)
      ct[u] = e.getUint32(n, !1);
    for (let u = 16; u < 64; u++) {
      const y = ct[u - 15], m = ct[u - 2], S = J(y, 7) ^ J(y, 18) ^ y >>> 3, h = J(m, 17) ^ J(m, 19) ^ m >>> 10;
      ct[u] = h + ct[u - 7] + S + ct[u - 16] | 0;
    }
    let { A: r, B: s, C: o, D: a, E: i, F: c, G: l, H: d } = this;
    for (let u = 0; u < 64; u++) {
      const y = J(i, 6) ^ J(i, 11) ^ J(i, 25), m = d + y + zi(i, c, l) + Wi[u] + ct[u] | 0, h = (J(r, 2) ^ J(r, 13) ^ J(r, 22)) + qi(r, s, o) | 0;
      d = l, l = c, c = i, i = a + m | 0, a = o, o = s, s = r, r = m + h | 0;
    }
    r = r + this.A | 0, s = s + this.B | 0, o = o + this.C | 0, a = a + this.D | 0, i = i + this.E | 0, c = c + this.F | 0, l = l + this.G | 0, d = d + this.H | 0, this.set(r, s, o, a, i, c, l, d);
  }
  roundClean() {
    ct.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
const Ar = /* @__PURE__ */ yr(() => new Ki());
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const xr = BigInt(0), fe = BigInt(1), Zi = BigInt(2), he = (t) => t instanceof Uint8Array, Yi = Array.from({ length: 256 }, (t, e) => e.toString(16).padStart(2, "0"));
function ht(t) {
  if (!he(t))
    throw new Error("Uint8Array expected");
  let e = "";
  for (let n = 0; n < t.length; n++)
    e += Yi[t[n]];
  return e;
}
function vr(t) {
  const e = t.toString(16);
  return e.length & 1 ? `0${e}` : e;
}
function ze(t) {
  if (typeof t != "string")
    throw new Error("hex string expected, got " + typeof t);
  return BigInt(t === "" ? "0" : `0x${t}`);
}
function pt(t) {
  if (typeof t != "string")
    throw new Error("hex string expected, got " + typeof t);
  if (t.length % 2)
    throw new Error("hex string is invalid: unpadded " + t.length);
  const e = new Uint8Array(t.length / 2);
  for (let n = 0; n < e.length; n++) {
    const r = n * 2, s = t.slice(r, r + 2), o = Number.parseInt(s, 16);
    if (Number.isNaN(o) || o < 0)
      throw new Error("invalid byte sequence");
    e[n] = o;
  }
  return e;
}
function X(t) {
  return ze(ht(t));
}
function qe(t) {
  if (!he(t))
    throw new Error("Uint8Array expected");
  return ze(ht(Uint8Array.from(t).reverse()));
}
const Et = (t, e) => pt(t.toString(16).padStart(e * 2, "0")), Ir = (t, e) => Et(t, e).reverse(), Xi = (t) => pt(vr(t));
function V(t, e, n) {
  let r;
  if (typeof e == "string")
    try {
      r = pt(e);
    } catch (o) {
      throw new Error(`${t} must be valid hex string, got "${e}". Cause: ${o}`);
    }
  else if (he(e))
    r = Uint8Array.from(e);
  else
    throw new Error(`${t} must be hex string or Uint8Array`);
  const s = r.length;
  if (typeof n == "number" && s !== n)
    throw new Error(`${t} expected ${n} bytes, got ${s}`);
  return r;
}
function Lt(...t) {
  const e = new Uint8Array(t.reduce((r, s) => r + s.length, 0));
  let n = 0;
  return t.forEach((r) => {
    if (!he(r))
      throw new Error("Uint8Array expected");
    e.set(r, n), n += r.length;
  }), e;
}
function Ji(t, e) {
  if (t.length !== e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (t[n] !== e[n])
      return !1;
  return !0;
}
function Qi(t) {
  if (typeof t != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof t}`);
  return new TextEncoder().encode(t);
}
function tc(t) {
  let e;
  for (e = 0; t > xr; t >>= fe, e += 1)
    ;
  return e;
}
const ec = (t, e) => t >> BigInt(e) & fe, nc = (t, e, n) => t | (n ? fe : xr) << BigInt(e), pe = (t) => (Zi << BigInt(t - 1)) - fe, xe = (t) => new Uint8Array(t), Cn = (t) => Uint8Array.from(t);
function Tr(t, e, n) {
  if (typeof t != "number" || t < 2)
    throw new Error("hashLen must be a number");
  if (typeof e != "number" || e < 2)
    throw new Error("qByteLen must be a number");
  if (typeof n != "function")
    throw new Error("hmacFn must be a function");
  let r = xe(t), s = xe(t), o = 0;
  const a = () => {
    r.fill(1), s.fill(0), o = 0;
  }, i = (...u) => n(s, r, ...u), c = (u = xe()) => {
    s = i(Cn([0]), u), r = i(), u.length !== 0 && (s = i(Cn([1]), u), r = i());
  }, l = () => {
    if (o++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let u = 0;
    const y = [];
    for (; u < e; ) {
      r = i();
      const m = r.slice();
      y.push(m), u += r.length;
    }
    return Lt(...y);
  };
  return (u, y) => {
    a(), c(u);
    let m;
    for (; !(m = y(l())); )
      c();
    return a(), m;
  };
}
const rc = {
  bigint: (t) => typeof t == "bigint",
  function: (t) => typeof t == "function",
  boolean: (t) => typeof t == "boolean",
  string: (t) => typeof t == "string",
  isSafeInteger: (t) => Number.isSafeInteger(t),
  array: (t) => Array.isArray(t),
  field: (t, e) => e.Fp.isValid(t),
  hash: (t) => typeof t == "function" && Number.isSafeInteger(t.outputLen)
};
function zt(t, e, n = {}) {
  const r = (s, o, a) => {
    const i = rc[o];
    if (typeof i != "function")
      throw new Error(`Invalid validator "${o}", expected function`);
    const c = t[s];
    if (!(a && c === void 0) && !i(c, t))
      throw new Error(`Invalid param ${String(s)}=${c} (${typeof c}), expected ${o}`);
  };
  for (const [s, o] of Object.entries(e))
    r(s, o, !1);
  for (const [s, o] of Object.entries(n))
    r(s, o, !0);
  return t;
}
const sc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bitGet: ec,
  bitLen: tc,
  bitMask: pe,
  bitSet: nc,
  bytesToHex: ht,
  bytesToNumberBE: X,
  bytesToNumberLE: qe,
  concatBytes: Lt,
  createHmacDrbg: Tr,
  ensureBytes: V,
  equalBytes: Ji,
  hexToBytes: pt,
  hexToNumber: ze,
  numberToBytesBE: Et,
  numberToBytesLE: Ir,
  numberToHexUnpadded: vr,
  numberToVarBytesBE: Xi,
  utf8ToBytes: Qi,
  validateObject: zt
}, Symbol.toStringTag, { value: "Module" }));
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const U = BigInt(0), $ = BigInt(1), ut = BigInt(2), oc = BigInt(3), _e = BigInt(4), On = BigInt(5), kn = BigInt(8);
BigInt(9);
BigInt(16);
function M(t, e) {
  const n = t % e;
  return n >= U ? n : e + n;
}
function ac(t, e, n) {
  if (n <= U || e < U)
    throw new Error("Expected power/modulo > 0");
  if (n === $)
    return U;
  let r = $;
  for (; e > U; )
    e & $ && (r = r * t % n), t = t * t % n, e >>= $;
  return r;
}
function Ne(t, e) {
  if (t === U || e <= U)
    throw new Error(`invert: expected positive integers, got n=${t} mod=${e}`);
  let n = M(t, e), r = e, s = U, o = $;
  for (; n !== U; ) {
    const i = r / n, c = r % n, l = s - o * i;
    r = n, n = c, s = o, o = l;
  }
  if (r !== $)
    throw new Error("invert: does not exist");
  return M(s, e);
}
function ic(t) {
  const e = (t - $) / ut;
  let n, r, s;
  for (n = t - $, r = 0; n % ut === U; n /= ut, r++)
    ;
  for (s = ut; s < t && ac(s, e, t) !== t - $; s++)
    ;
  if (r === 1) {
    const a = (t + $) / _e;
    return function(c, l) {
      const d = c.pow(l, a);
      if (!c.eql(c.sqr(d), l))
        throw new Error("Cannot find square root");
      return d;
    };
  }
  const o = (n + $) / ut;
  return function(i, c) {
    if (i.pow(c, e) === i.neg(i.ONE))
      throw new Error("Cannot find square root");
    let l = r, d = i.pow(i.mul(i.ONE, s), n), u = i.pow(c, o), y = i.pow(c, n);
    for (; !i.eql(y, i.ONE); ) {
      if (i.eql(y, i.ZERO))
        return i.ZERO;
      let m = 1;
      for (let h = i.sqr(y); m < l && !i.eql(h, i.ONE); m++)
        h = i.sqr(h);
      const S = i.pow(d, $ << BigInt(l - m - 1));
      d = i.sqr(S), u = i.mul(u, S), y = i.mul(y, d), l = m;
    }
    return u;
  };
}
function cc(t) {
  if (t % _e === oc) {
    const e = (t + $) / _e;
    return function(r, s) {
      const o = r.pow(s, e);
      if (!r.eql(r.sqr(o), s))
        throw new Error("Cannot find square root");
      return o;
    };
  }
  if (t % kn === On) {
    const e = (t - On) / kn;
    return function(r, s) {
      const o = r.mul(s, ut), a = r.pow(o, e), i = r.mul(s, a), c = r.mul(r.mul(i, ut), a), l = r.mul(i, r.sub(c, r.ONE));
      if (!r.eql(r.sqr(l), s))
        throw new Error("Cannot find square root");
      return l;
    };
  }
  return ic(t);
}
const lc = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function We(t) {
  const e = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, n = lc.reduce((r, s) => (r[s] = "function", r), e);
  return zt(t, n);
}
function Br(t, e, n) {
  if (n < U)
    throw new Error("Expected power > 0");
  if (n === U)
    return t.ONE;
  if (n === $)
    return e;
  let r = t.ONE, s = e;
  for (; n > U; )
    n & $ && (r = t.mul(r, s)), s = t.sqr(s), n >>= $;
  return r;
}
function uc(t, e) {
  const n = new Array(e.length), r = e.reduce((o, a, i) => t.is0(a) ? o : (n[i] = o, t.mul(o, a)), t.ONE), s = t.inv(r);
  return e.reduceRight((o, a, i) => t.is0(a) ? o : (n[i] = t.mul(o, n[i]), t.mul(o, a)), s), n;
}
function Ke(t, e) {
  const n = e !== void 0 ? e : t.toString(2).length, r = Math.ceil(n / 8);
  return { nBitLength: n, nByteLength: r };
}
function Ze(t, e, n = !1, r = {}) {
  if (t <= U)
    throw new Error(`Expected Fp ORDER > 0, got ${t}`);
  const { nBitLength: s, nByteLength: o } = Ke(t, e);
  if (o > 2048)
    throw new Error("Field lengths over 2048 bytes are not supported");
  const a = cc(t), i = Object.freeze({
    ORDER: t,
    BITS: s,
    BYTES: o,
    MASK: pe(s),
    ZERO: U,
    ONE: $,
    create: (c) => M(c, t),
    isValid: (c) => {
      if (typeof c != "bigint")
        throw new Error(`Invalid field element: expected bigint, got ${typeof c}`);
      return U <= c && c < t;
    },
    is0: (c) => c === U,
    isOdd: (c) => (c & $) === $,
    neg: (c) => M(-c, t),
    eql: (c, l) => c === l,
    sqr: (c) => M(c * c, t),
    add: (c, l) => M(c + l, t),
    sub: (c, l) => M(c - l, t),
    mul: (c, l) => M(c * l, t),
    pow: (c, l) => Br(i, c, l),
    div: (c, l) => M(c * Ne(l, t), t),
    // Same as above, but doesn't normalize
    sqrN: (c) => c * c,
    addN: (c, l) => c + l,
    subN: (c, l) => c - l,
    mulN: (c, l) => c * l,
    inv: (c) => Ne(c, t),
    sqrt: r.sqrt || ((c) => a(i, c)),
    invertBatch: (c) => uc(i, c),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (c, l, d) => d ? l : c,
    toBytes: (c) => n ? Ir(c, o) : Et(c, o),
    fromBytes: (c) => {
      if (c.length !== o)
        throw new Error(`Fp.fromBytes: expected ${o}, got ${c.length}`);
      return n ? qe(c) : X(c);
    }
  });
  return Object.freeze(i);
}
function dc(t, e, n = !1) {
  t = V("privateHash", t);
  const r = t.length, s = Ke(e).nByteLength + 8;
  if (s < 24 || r < s || r > 1024)
    throw new Error(`hashToPrivateScalar: expected ${s}-1024 bytes of input, got ${r}`);
  const o = n ? qe(t) : X(t);
  return M(o, e - $) + $;
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function fc(t) {
  const { Fp: e } = t;
  We(e);
  for (const c of ["t", "roundsFull", "roundsPartial"])
    if (typeof t[c] != "number" || !Number.isSafeInteger(t[c]))
      throw new Error(`Poseidon: invalid param ${c}=${t[c]} (${typeof t[c]})`);
  if (t.reversePartialPowIdx !== void 0 && typeof t.reversePartialPowIdx != "boolean")
    throw new Error(`Poseidon: invalid param reversePartialPowIdx=${t.reversePartialPowIdx}`);
  let n = t.sboxPower;
  if (n === void 0 && (n = 5), typeof n != "number" || !Number.isSafeInteger(n))
    throw new Error(`Poseidon wrong sboxPower=${n}`);
  const r = BigInt(n);
  let s = (c) => Br(e, c, r);
  if (n === 3 ? s = (c) => e.mul(e.sqrN(c), c) : n === 5 && (s = (c) => e.mul(e.sqrN(e.sqrN(c)), c)), t.roundsFull % 2 !== 0)
    throw new Error(`Poseidon roundsFull is not even: ${t.roundsFull}`);
  const o = t.roundsFull + t.roundsPartial;
  if (!Array.isArray(t.roundConstants) || t.roundConstants.length !== o)
    throw new Error("Poseidon: wrong round constants");
  const a = t.roundConstants.map((c) => {
    if (!Array.isArray(c) || c.length !== t.t)
      throw new Error(`Poseidon wrong round constants: ${c}`);
    return c.map((l) => {
      if (typeof l != "bigint" || !e.isValid(l))
        throw new Error(`Poseidon wrong round constant=${l}`);
      return e.create(l);
    });
  });
  if (!Array.isArray(t.mds) || t.mds.length !== t.t)
    throw new Error("Poseidon: wrong MDS matrix");
  const i = t.mds.map((c) => {
    if (!Array.isArray(c) || c.length !== t.t)
      throw new Error(`Poseidon MDS matrix row: ${c}`);
    return c.map((l) => {
      if (typeof l != "bigint")
        throw new Error(`Poseidon MDS matrix value=${l}`);
      return e.create(l);
    });
  });
  return Object.freeze({ ...t, rounds: o, sboxFn: s, roundConstants: a, mds: i });
}
function hc(t) {
  const { t: e, Fp: n, rounds: r, sboxFn: s, reversePartialPowIdx: o } = fc(t), a = Math.floor(t.roundsFull / 2), i = o ? e - 1 : 0, c = (d, u, y) => (d = d.map((m, S) => n.add(m, t.roundConstants[y][S])), u ? d = d.map((m) => s(m)) : d[i] = s(d[i]), d = t.mds.map((m) => m.reduce((S, h, g) => n.add(S, n.mulN(h, d[g])), n.ZERO)), d), l = function(u) {
    if (!Array.isArray(u) || u.length !== e)
      throw new Error(`Poseidon: wrong values (expected array of bigints with length ${e})`);
    u = u.map((m) => {
      if (typeof m != "bigint")
        throw new Error(`Poseidon: wrong value=${m} (${typeof m})`);
      return n.create(m);
    });
    let y = 0;
    for (let m = 0; m < a; m++)
      u = c(u, !0, y++);
    for (let m = 0; m < t.roundsPartial; m++)
      u = c(u, !1, y++);
    for (let m = 0; m < a; m++)
      u = c(u, !0, y++);
    if (y !== r)
      throw new Error(`Poseidon: wrong number of rounds: last round=${y}, total=${r}`);
    return u;
  };
  return l.roundConstants = t.roundConstants, l;
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const pc = BigInt(0), ve = BigInt(1);
function mc(t, e) {
  const n = (s, o) => {
    const a = o.negate();
    return s ? a : o;
  }, r = (s) => {
    const o = Math.ceil(e / s) + 1, a = 2 ** (s - 1);
    return { windows: o, windowSize: a };
  };
  return {
    constTimeNegate: n,
    // non-const time multiplication ladder
    unsafeLadder(s, o) {
      let a = t.ZERO, i = s;
      for (; o > pc; )
        o & ve && (a = a.add(i)), i = i.double(), o >>= ve;
      return a;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(s, o) {
      const { windows: a, windowSize: i } = r(o), c = [];
      let l = s, d = l;
      for (let u = 0; u < a; u++) {
        d = l, c.push(d);
        for (let y = 1; y < i; y++)
          d = d.add(l), c.push(d);
        l = d.double();
      }
      return c;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(s, o, a) {
      const { windows: i, windowSize: c } = r(s);
      let l = t.ZERO, d = t.BASE;
      const u = BigInt(2 ** s - 1), y = 2 ** s, m = BigInt(s);
      for (let S = 0; S < i; S++) {
        const h = S * c;
        let g = Number(a & u);
        a >>= m, g > c && (g -= y, a += ve);
        const w = h, E = h + Math.abs(g) - 1, x = S % 2 !== 0, _ = g < 0;
        g === 0 ? d = d.add(n(x, o[w])) : l = l.add(n(_, o[E]));
      }
      return { p: l, f: d };
    },
    wNAFCached(s, o, a, i) {
      const c = s._WINDOW_SIZE || 1;
      let l = o.get(s);
      return l || (l = this.precomputeWindow(s, c), c !== 1 && o.set(s, i(l))), this.wNAF(c, l, a);
    }
  };
}
function _r(t) {
  return We(t.Fp), zt(t, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...Ke(t.n, t.nBitLength),
    ...t,
    p: t.Fp.ORDER
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function gc(t) {
  const e = _r(t);
  zt(e, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: n, Fp: r, a: s } = e;
  if (n) {
    if (!r.eql(s, r.ZERO))
      throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
    if (typeof n != "object" || typeof n.beta != "bigint" || typeof n.splitScalar != "function")
      throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...e });
}
const { bytesToNumberBE: wc, hexToBytes: yc } = sc, dt = {
  // asn.1 DER encoding utils
  Err: class extends Error {
    constructor(e = "") {
      super(e);
    }
  },
  _parseInt(t) {
    const { Err: e } = dt;
    if (t.length < 2 || t[0] !== 2)
      throw new e("Invalid signature integer tag");
    const n = t[1], r = t.subarray(2, n + 2);
    if (!n || r.length !== n)
      throw new e("Invalid signature integer: wrong length");
    if (r[0] & 128)
      throw new e("Invalid signature integer: negative");
    if (r[0] === 0 && !(r[1] & 128))
      throw new e("Invalid signature integer: unnecessary leading zero");
    return { d: wc(r), l: t.subarray(n + 2) };
  },
  toSig(t) {
    const { Err: e } = dt, n = typeof t == "string" ? yc(t) : t;
    if (!(n instanceof Uint8Array))
      throw new Error("ui8a expected");
    let r = n.length;
    if (r < 2 || n[0] != 48)
      throw new e("Invalid signature tag");
    if (n[1] !== r - 2)
      throw new e("Invalid signature: incorrect length");
    const { d: s, l: o } = dt._parseInt(n.subarray(2)), { d: a, l: i } = dt._parseInt(o);
    if (i.length)
      throw new e("Invalid signature: left bytes after parsing");
    return { r: s, s: a };
  },
  hexFromSig(t) {
    const e = (l) => Number.parseInt(l[0], 16) & 8 ? "00" + l : l, n = (l) => {
      const d = l.toString(16);
      return d.length & 1 ? `0${d}` : d;
    }, r = e(n(t.s)), s = e(n(t.r)), o = r.length / 2, a = s.length / 2, i = n(o), c = n(a);
    return `30${n(a + o + 4)}02${c}${s}02${i}${r}`;
  }
}, et = BigInt(0), q = BigInt(1);
BigInt(2);
const Pn = BigInt(3);
BigInt(4);
function bc(t) {
  const e = gc(t), { Fp: n } = e, r = e.toBytes || ((S, h, g) => {
    const w = h.toAffine();
    return Lt(Uint8Array.from([4]), n.toBytes(w.x), n.toBytes(w.y));
  }), s = e.fromBytes || ((S) => {
    const h = S.subarray(1), g = n.fromBytes(h.subarray(0, n.BYTES)), w = n.fromBytes(h.subarray(n.BYTES, 2 * n.BYTES));
    return { x: g, y: w };
  });
  function o(S) {
    const { a: h, b: g } = e, w = n.sqr(S), E = n.mul(w, S);
    return n.add(n.add(E, n.mul(S, h)), g);
  }
  if (!n.eql(n.sqr(e.Gy), o(e.Gx)))
    throw new Error("bad generator point: equation left != right");
  function a(S) {
    return typeof S == "bigint" && et < S && S < e.n;
  }
  function i(S) {
    if (!a(S))
      throw new Error("Expected valid bigint: 0 < bigint < curve.n");
  }
  function c(S) {
    const { allowedPrivateKeyLengths: h, nByteLength: g, wrapPrivateKey: w, n: E } = e;
    if (h && typeof S != "bigint") {
      if (S instanceof Uint8Array && (S = ht(S)), typeof S != "string" || !h.includes(S.length))
        throw new Error("Invalid key");
      S = S.padStart(g * 2, "0");
    }
    let x;
    try {
      x = typeof S == "bigint" ? S : X(V("private key", S, g));
    } catch {
      throw new Error(`private key must be ${g} bytes, hex or bigint, not ${typeof S}`);
    }
    return w && (x = M(x, E)), i(x), x;
  }
  const l = /* @__PURE__ */ new Map();
  function d(S) {
    if (!(S instanceof u))
      throw new Error("ProjectivePoint expected");
  }
  class u {
    constructor(h, g, w) {
      if (this.px = h, this.py = g, this.pz = w, h == null || !n.isValid(h))
        throw new Error("x required");
      if (g == null || !n.isValid(g))
        throw new Error("y required");
      if (w == null || !n.isValid(w))
        throw new Error("z required");
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(h) {
      const { x: g, y: w } = h || {};
      if (!h || !n.isValid(g) || !n.isValid(w))
        throw new Error("invalid affine point");
      if (h instanceof u)
        throw new Error("projective point not allowed");
      const E = (x) => n.eql(x, n.ZERO);
      return E(g) && E(w) ? u.ZERO : new u(g, w, n.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(h) {
      const g = n.invertBatch(h.map((w) => w.pz));
      return h.map((w, E) => w.toAffine(g[E])).map(u.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(h) {
      const g = u.fromAffine(s(V("pointHex", h)));
      return g.assertValidity(), g;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(h) {
      return u.BASE.multiply(c(h));
    }
    // "Private method", don't use it directly
    _setWindowSize(h) {
      this._WINDOW_SIZE = h, l.delete(this);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      if (this.is0()) {
        if (e.allowInfinityPoint)
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: h, y: g } = this.toAffine();
      if (!n.isValid(h) || !n.isValid(g))
        throw new Error("bad point: x or y not FE");
      const w = n.sqr(g), E = o(h);
      if (!n.eql(w, E))
        throw new Error("bad point: equation left != right");
      if (!this.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
    }
    hasEvenY() {
      const { y: h } = this.toAffine();
      if (n.isOdd)
        return !n.isOdd(h);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(h) {
      d(h);
      const { px: g, py: w, pz: E } = this, { px: x, py: _, pz: B } = h, A = n.eql(n.mul(g, B), n.mul(x, E)), v = n.eql(n.mul(w, B), n.mul(_, E));
      return A && v;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new u(this.px, n.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: h, b: g } = e, w = n.mul(g, Pn), { px: E, py: x, pz: _ } = this;
      let B = n.ZERO, A = n.ZERO, v = n.ZERO, T = n.mul(E, E), G = n.mul(x, x), R = n.mul(_, _), N = n.mul(E, x);
      return N = n.add(N, N), v = n.mul(E, _), v = n.add(v, v), B = n.mul(h, v), A = n.mul(w, R), A = n.add(B, A), B = n.sub(G, A), A = n.add(G, A), A = n.mul(B, A), B = n.mul(N, B), v = n.mul(w, v), R = n.mul(h, R), N = n.sub(T, R), N = n.mul(h, N), N = n.add(N, v), v = n.add(T, T), T = n.add(v, T), T = n.add(T, R), T = n.mul(T, N), A = n.add(A, T), R = n.mul(x, _), R = n.add(R, R), T = n.mul(R, N), B = n.sub(B, T), v = n.mul(R, G), v = n.add(v, v), v = n.add(v, v), new u(B, A, v);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(h) {
      d(h);
      const { px: g, py: w, pz: E } = this, { px: x, py: _, pz: B } = h;
      let A = n.ZERO, v = n.ZERO, T = n.ZERO;
      const G = e.a, R = n.mul(e.b, Pn);
      let N = n.mul(g, x), L = n.mul(w, _), D = n.mul(E, B), rt = n.add(g, w), p = n.add(x, _);
      rt = n.mul(rt, p), p = n.add(N, L), rt = n.sub(rt, p), p = n.add(g, E);
      let b = n.add(x, B);
      return p = n.mul(p, b), b = n.add(N, D), p = n.sub(p, b), b = n.add(w, E), A = n.add(_, B), b = n.mul(b, A), A = n.add(L, D), b = n.sub(b, A), T = n.mul(G, p), A = n.mul(R, D), T = n.add(A, T), A = n.sub(L, T), T = n.add(L, T), v = n.mul(A, T), L = n.add(N, N), L = n.add(L, N), D = n.mul(G, D), p = n.mul(R, p), L = n.add(L, D), D = n.sub(N, D), D = n.mul(G, D), p = n.add(p, D), N = n.mul(L, p), v = n.add(v, N), N = n.mul(b, p), A = n.mul(rt, A), A = n.sub(A, N), N = n.mul(rt, L), T = n.mul(b, T), T = n.add(T, N), new u(A, v, T);
    }
    subtract(h) {
      return this.add(h.negate());
    }
    is0() {
      return this.equals(u.ZERO);
    }
    wNAF(h) {
      return m.wNAFCached(this, l, h, (g) => {
        const w = n.invertBatch(g.map((E) => E.pz));
        return g.map((E, x) => E.toAffine(w[x])).map(u.fromAffine);
      });
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(h) {
      const g = u.ZERO;
      if (h === et)
        return g;
      if (i(h), h === q)
        return this;
      const { endo: w } = e;
      if (!w)
        return m.unsafeLadder(this, h);
      let { k1neg: E, k1: x, k2neg: _, k2: B } = w.splitScalar(h), A = g, v = g, T = this;
      for (; x > et || B > et; )
        x & q && (A = A.add(T)), B & q && (v = v.add(T)), T = T.double(), x >>= q, B >>= q;
      return E && (A = A.negate()), _ && (v = v.negate()), v = new u(n.mul(v.px, w.beta), v.py, v.pz), A.add(v);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(h) {
      i(h);
      let g = h, w, E;
      const { endo: x } = e;
      if (x) {
        const { k1neg: _, k1: B, k2neg: A, k2: v } = x.splitScalar(g);
        let { p: T, f: G } = this.wNAF(B), { p: R, f: N } = this.wNAF(v);
        T = m.constTimeNegate(_, T), R = m.constTimeNegate(A, R), R = new u(n.mul(R.px, x.beta), R.py, R.pz), w = T.add(R), E = G.add(N);
      } else {
        const { p: _, f: B } = this.wNAF(g);
        w = _, E = B;
      }
      return u.normalizeZ([w, E])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(h, g, w) {
      const E = u.BASE, x = (B, A) => A === et || A === q || !B.equals(E) ? B.multiplyUnsafe(A) : B.multiply(A), _ = x(this, g).add(x(h, w));
      return _.is0() ? void 0 : _;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(h) {
      const { px: g, py: w, pz: E } = this, x = this.is0();
      h == null && (h = x ? n.ONE : n.inv(E));
      const _ = n.mul(g, h), B = n.mul(w, h), A = n.mul(E, h);
      if (x)
        return { x: n.ZERO, y: n.ZERO };
      if (!n.eql(A, n.ONE))
        throw new Error("invZ was invalid");
      return { x: _, y: B };
    }
    isTorsionFree() {
      const { h, isTorsionFree: g } = e;
      if (h === q)
        return !0;
      if (g)
        return g(u, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h, clearCofactor: g } = e;
      return h === q ? this : g ? g(u, this) : this.multiplyUnsafe(e.h);
    }
    toRawBytes(h = !0) {
      return this.assertValidity(), r(u, this, h);
    }
    toHex(h = !0) {
      return ht(this.toRawBytes(h));
    }
  }
  u.BASE = new u(e.Gx, e.Gy, n.ONE), u.ZERO = new u(n.ZERO, n.ONE, n.ZERO);
  const y = e.nBitLength, m = mc(u, e.endo ? Math.ceil(y / 2) : y);
  return {
    CURVE: e,
    ProjectivePoint: u,
    normPrivateKeyToScalar: c,
    weierstrassEquation: o,
    isWithinCurveOrder: a
  };
}
function Sc(t) {
  const e = _r(t);
  return zt(e, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...e });
}
function Ec(t) {
  const e = Sc(t), { Fp: n, n: r } = e, s = n.BYTES + 1, o = 2 * n.BYTES + 1;
  function a(p) {
    return et < p && p < n.ORDER;
  }
  function i(p) {
    return M(p, r);
  }
  function c(p) {
    return Ne(p, r);
  }
  const { ProjectivePoint: l, normPrivateKeyToScalar: d, weierstrassEquation: u, isWithinCurveOrder: y } = bc({
    ...e,
    toBytes(p, b, I) {
      const P = b.toAffine(), C = n.toBytes(P.x), j = Lt;
      return I ? j(Uint8Array.from([b.hasEvenY() ? 2 : 3]), C) : j(Uint8Array.from([4]), C, n.toBytes(P.y));
    },
    fromBytes(p) {
      const b = p.length, I = p[0], P = p.subarray(1);
      if (b === s && (I === 2 || I === 3)) {
        const C = X(P);
        if (!a(C))
          throw new Error("Point is not on curve");
        const j = u(C);
        let z = n.sqrt(j);
        const H = (z & q) === q;
        return (I & 1) === 1 !== H && (z = n.neg(z)), { x: C, y: z };
      } else if (b === o && I === 4) {
        const C = n.fromBytes(P.subarray(0, n.BYTES)), j = n.fromBytes(P.subarray(n.BYTES, 2 * n.BYTES));
        return { x: C, y: j };
      } else
        throw new Error(`Point of length ${b} was invalid. Expected ${s} compressed bytes or ${o} uncompressed bytes`);
    }
  }), m = (p) => ht(Et(p, e.nByteLength));
  function S(p) {
    const b = r >> q;
    return p > b;
  }
  function h(p) {
    return S(p) ? i(-p) : p;
  }
  const g = (p, b, I) => X(p.slice(b, I));
  class w {
    constructor(b, I, P) {
      this.r = b, this.s = I, this.recovery = P, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(b) {
      const I = e.nByteLength;
      return b = V("compactSignature", b, I * 2), new w(g(b, 0, I), g(b, I, 2 * I));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(b) {
      const { r: I, s: P } = dt.toSig(V("DER", b));
      return new w(I, P);
    }
    assertValidity() {
      if (!y(this.r))
        throw new Error("r must be 0 < r < CURVE.n");
      if (!y(this.s))
        throw new Error("s must be 0 < s < CURVE.n");
    }
    addRecoveryBit(b) {
      return new w(this.r, this.s, b);
    }
    recoverPublicKey(b) {
      const { r: I, s: P, recovery: C } = this, j = v(V("msgHash", b));
      if (C == null || ![0, 1, 2, 3].includes(C))
        throw new Error("recovery id invalid");
      const z = C === 2 || C === 3 ? I + e.n : I;
      if (z >= n.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const H = C & 1 ? "03" : "02", st = l.fromHex(H + m(z)), ot = c(z), gt = i(-j * ot), Bt = i(P * ot), at = l.BASE.multiplyAndAddUnsafe(st, gt, Bt);
      if (!at)
        throw new Error("point at infinify");
      return at.assertValidity(), at;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return S(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new w(this.r, i(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return pt(this.toDERHex());
    }
    toDERHex() {
      return dt.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return pt(this.toCompactHex());
    }
    toCompactHex() {
      return m(this.r) + m(this.s);
    }
  }
  const E = {
    isValidPrivateKey(p) {
      try {
        return d(p), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: d,
    /**
     * Produces cryptographically secure private key from random of size (nBitLength+64)
     * as per FIPS 186 B.4.1 with modulo bias being neglible.
     */
    randomPrivateKey: () => {
      const p = e.randomBytes(n.BYTES + 8), b = dc(p, r);
      return Et(b, e.nByteLength);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(p = 8, b = l.BASE) {
      return b._setWindowSize(p), b.multiply(BigInt(3)), b;
    }
  };
  function x(p, b = !0) {
    return l.fromPrivateKey(p).toRawBytes(b);
  }
  function _(p) {
    const b = p instanceof Uint8Array, I = typeof p == "string", P = (b || I) && p.length;
    return b ? P === s || P === o : I ? P === 2 * s || P === 2 * o : p instanceof l;
  }
  function B(p, b, I = !0) {
    if (_(p))
      throw new Error("first arg must be private key");
    if (!_(b))
      throw new Error("second arg must be public key");
    return l.fromHex(b).multiply(d(p)).toRawBytes(I);
  }
  const A = e.bits2int || function(p) {
    const b = X(p), I = p.length * 8 - e.nBitLength;
    return I > 0 ? b >> BigInt(I) : b;
  }, v = e.bits2int_modN || function(p) {
    return i(A(p));
  }, T = pe(e.nBitLength);
  function G(p) {
    if (typeof p != "bigint")
      throw new Error("bigint expected");
    if (!(et <= p && p < T))
      throw new Error(`bigint expected < 2^${e.nBitLength}`);
    return Et(p, e.nByteLength);
  }
  function R(p, b, I = N) {
    if (["recovered", "canonical"].some((lt) => lt in I))
      throw new Error("sign() legacy options not supported");
    const { hash: P, randomBytes: C } = e;
    let { lowS: j, prehash: z, extraEntropy: H } = I;
    j == null && (j = !0), p = V("msgHash", p), z && (p = V("prehashed msgHash", P(p)));
    const st = v(p), ot = d(b), gt = [G(ot), G(st)];
    if (H != null) {
      const lt = H === !0 ? C(n.BYTES) : H;
      gt.push(V("extraEntropy", lt, n.BYTES));
    }
    const Bt = Lt(...gt), at = st;
    function we(lt) {
      const wt = A(lt);
      if (!y(wt))
        return;
      const Je = c(wt), yt = l.BASE.multiply(wt).toAffine(), W = i(yt.x);
      if (W === et)
        return;
      const bt = i(Je * i(at + W * ot));
      if (bt === et)
        return;
      let Qe = (yt.x === W ? 0 : 2) | Number(yt.y & q), tn = bt;
      return j && S(bt) && (tn = h(bt), Qe ^= 1), new w(W, tn, Qe);
    }
    return { seed: Bt, k2sig: we };
  }
  const N = { lowS: e.lowS, prehash: !1 }, L = { lowS: e.lowS, prehash: !1 };
  function D(p, b, I = N) {
    const { seed: P, k2sig: C } = R(p, b, I);
    return Tr(e.hash.outputLen, e.nByteLength, e.hmac)(P, C);
  }
  l.BASE._setWindowSize(8);
  function rt(p, b, I, P = L) {
    var yt;
    const C = p;
    if (b = V("msgHash", b), I = V("publicKey", I), "strict" in P)
      throw new Error("options.strict was renamed to lowS");
    const { lowS: j, prehash: z } = P;
    let H, st;
    try {
      if (typeof C == "string" || C instanceof Uint8Array)
        try {
          H = w.fromDER(C);
        } catch (W) {
          if (!(W instanceof dt.Err))
            throw W;
          H = w.fromCompact(C);
        }
      else if (typeof C == "object" && typeof C.r == "bigint" && typeof C.s == "bigint") {
        const { r: W, s: bt } = C;
        H = new w(W, bt);
      } else
        throw new Error("PARSE");
      st = l.fromHex(I);
    } catch (W) {
      if (W.message === "PARSE")
        throw new Error("signature must be Signature instance, Uint8Array or hex string");
      return !1;
    }
    if (j && H.hasHighS())
      return !1;
    z && (b = e.hash(b));
    const { r: ot, s: gt } = H, Bt = v(b), at = c(gt), we = i(Bt * at), lt = i(ot * at), wt = (yt = l.BASE.multiplyAndAddUnsafe(st, we, lt)) == null ? void 0 : yt.toAffine();
    return wt ? i(wt.x) === ot : !1;
  }
  return {
    CURVE: e,
    getPublicKey: x,
    getSharedSecret: B,
    sign: D,
    verify: rt,
    ProjectivePoint: l,
    Signature: w,
    utils: E
  };
}
function Ce(t) {
  if (!Number.isSafeInteger(t) || t < 0)
    throw new Error(`Wrong positive integer: ${t}`);
}
function Ac(t) {
  if (typeof t != "boolean")
    throw new Error(`Expected boolean, not ${t}`);
}
function Nr(t, ...e) {
  if (!(t instanceof Uint8Array))
    throw new TypeError("Expected Uint8Array");
  if (e.length > 0 && !e.includes(t.length))
    throw new TypeError(`Expected Uint8Array of length ${e}, not of length=${t.length}`);
}
function xc(t) {
  if (typeof t != "function" || typeof t.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  Ce(t.outputLen), Ce(t.blockLen);
}
function vc(t, e = !0) {
  if (t.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (e && t.finished)
    throw new Error("Hash#digest() has already been called");
}
function Ic(t, e) {
  Nr(t);
  const n = e.outputLen;
  if (t.length < n)
    throw new Error(`digestInto() expects output buffer of length at least ${n}`);
}
const Yt = {
  number: Ce,
  bool: Ac,
  bytes: Nr,
  hash: xc,
  exists: vc,
  output: Ic
}, Ie = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Tc = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!Tc)
  throw new Error("Non little-endian hardware is not supported");
Array.from({ length: 256 }, (t, e) => e.toString(16).padStart(2, "0"));
function Bc(t) {
  if (typeof t != "string")
    throw new TypeError(`utf8ToBytes expected string, got ${typeof t}`);
  return new TextEncoder().encode(t);
}
function _c(t) {
  if (typeof t == "string" && (t = Bc(t)), !(t instanceof Uint8Array))
    throw new TypeError(`Expected input type is Uint8Array (got ${typeof t})`);
  return t;
}
function Nc(...t) {
  if (!t.every((r) => r instanceof Uint8Array))
    throw new Error("Uint8Array list expected");
  if (t.length === 1)
    return t[0];
  const e = t.reduce((r, s) => r + s.length, 0), n = new Uint8Array(e);
  for (let r = 0, s = 0; r < t.length; r++) {
    const o = t[r];
    n.set(o, s), s += o.length;
  }
  return n;
}
class Cc {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function Oc(t = 32) {
  if (Ie && typeof Ie.getRandomValues == "function")
    return Ie.getRandomValues(new Uint8Array(t));
  throw new Error("crypto.getRandomValues must be defined");
}
class Cr extends Cc {
  constructor(e, n) {
    super(), this.finished = !1, this.destroyed = !1, Yt.hash(e);
    const r = _c(n);
    if (this.iHash = e.create(), typeof this.iHash.update != "function")
      throw new TypeError("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const s = this.blockLen, o = new Uint8Array(s);
    o.set(r.length > s ? e.create().update(r).digest() : r);
    for (let a = 0; a < o.length; a++)
      o[a] ^= 54;
    this.iHash.update(o), this.oHash = e.create();
    for (let a = 0; a < o.length; a++)
      o[a] ^= 106;
    this.oHash.update(o), o.fill(0);
  }
  update(e) {
    return Yt.exists(this), this.iHash.update(e), this;
  }
  digestInto(e) {
    Yt.exists(this), Yt.bytes(e, this.outputLen), this.finished = !0, this.iHash.digestInto(e), this.oHash.update(e), this.oHash.digestInto(e), this.destroy();
  }
  digest() {
    const e = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(e), e;
  }
  _cloneInto(e) {
    e || (e = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: n, iHash: r, finished: s, destroyed: o, blockLen: a, outputLen: i } = this;
    return e = e, e.finished = s, e.destroyed = o, e.blockLen = a, e.outputLen = i, e.oHash = n._cloneInto(e.oHash), e.iHash = r._cloneInto(e.iHash), e;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const Or = (t, e, n) => new Cr(t, e).update(n).digest();
Or.create = (t, e) => new Cr(t, e);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function kc(t) {
  return {
    hash: t,
    hmac: (e, ...n) => Or(t, e, Nc(...n)),
    randomBytes: Oc
  };
}
const Rn = BigInt("3618502788666131213697322783095070105526743751716087489154079457884512865583"), kr = 252;
function $n(t) {
  for (; t[0] === 0; )
    t = t.subarray(1);
  const e = t.length * 8 - kr, n = X(t);
  return e > 0 ? n >> BigInt(e) : n;
}
function Pr(t) {
  return typeof t == "string" && (t = $c(t), t.length & 1 && (t = "0" + t)), pt(t);
}
const Rr = Ec({
  a: BigInt(1),
  b: BigInt("3141592653589793238462643383279502884197169399375105820974944592307816406665"),
  Fp: Ze(BigInt("0x800000000000011000000000000000000000000000000000000000000000001")),
  n: Rn,
  nBitLength: kr,
  Gx: BigInt("874739451078007766457464989774322083649278607533249481151382481072868806602"),
  Gy: BigInt("152666792071518830868575557812948353041420400780739481342941381225525861407"),
  h: BigInt(1),
  lowS: !1,
  ...kc(Ar),
  bits2int: $n,
  bits2int_modN: (t) => {
    const e = X(t).toString(16);
    return e.length === 63 && (t = Pr(e + "0")), M($n(t), Rn);
  }
});
function Pc(t) {
  return V("", typeof t == "string" ? Pr(t) : t);
}
const { CURVE: _u, ProjectivePoint: kt, Signature: Nu, utils: Cu } = Rr;
function Rc(t) {
  return `0x${ht(t.subarray(1)).replace(/^0+/gm, "")}`;
}
function $c(t) {
  return t.replace(/^0x/i, "");
}
const Dt = [
  new kt(2089986280348253421170679821480865132823066470938446095505822317253594081284n, 1713931329540660377023406109199410414810705867260802078187082345529207694986n, 1n),
  new kt(996781205833008774514500082376783249102396023663454813447423147977397232763n, 1668503676786377725805489344771023921079126552019160156920634619255970485781n, 1n),
  new kt(2251563274489750535117886426533222435294046428347329203627021249169616184184n, 1798716007562728905295480679789526322175868328062420237419143593021674992973n, 1n),
  new kt(2138414695194151160943305727036575959195309218611738193261179310511854807447n, 113410276730064486255102093846540133784865286929052426931474106396135072156n, 1n),
  new kt(2379962749567351885752724891227938183011949129833673362440656643086021394946n, 776496453633298175483985398648758586525933812536653089401905292063708816422n, 1n)
];
function $r(t, e) {
  const n = [];
  let r = t;
  for (let s = 0; s < 248; s++)
    n.push(r), r = r.double();
  r = e;
  for (let s = 0; s < 4; s++)
    n.push(r), r = r.double();
  return n;
}
const Fc = $r(Dt[1], Dt[2]), Uc = $r(Dt[3], Dt[4]);
function jc(t) {
  let e;
  if (typeof t == "bigint")
    e = t;
  else if (typeof t == "number") {
    if (!Number.isSafeInteger(t))
      throw new Error(`Invalid pedersenArg: ${t}`);
    e = BigInt(t);
  } else
    e = X(Pc(t));
  if (!(0n <= e && e < Rr.CURVE.Fp.ORDER))
    throw new Error(`PedersenArg should be 0 <= value < CURVE.P: ${e}`);
  return e;
}
function Fn(t, e, n) {
  let r = jc(e);
  for (let s = 0; s < 252; s++) {
    const o = n[s];
    if (o.equals(t))
      throw new Error("Same point");
    (r & 1n) !== 0n && (t = t.add(o)), r >>= 1n;
  }
  return t;
}
function Lc(t, e) {
  let n = Dt[0];
  return n = Fn(n, t, Fc), n = Fn(n, e, Uc), Rc(n.toRawBytes(!0));
}
const Dc = pe(250), Hc = (t) => X(Vi(t)) & Dc;
Ze(BigInt("14474011154664525231415395255581126252639794253786371766033694892385558855681"));
const Vc = Ze(BigInt("3618502788666131213697322783095070105623107215331596699973092056135872020481"));
function Mc(t, e, n) {
  const r = t.fromBytes(Ar(gr(`${e}${n}`)));
  return t.create(r);
}
const Gc = [
  [3, 1, 1],
  [1, -1, 1],
  [1, 1, -2]
].map((t) => t.map(BigInt));
function zc(t, e) {
  if (We(t.Fp), !Number.isSafeInteger(t.rate) || !Number.isSafeInteger(t.capacity))
    throw new Error(`Wrong poseidon opts: ${t}`);
  const n = t.rate + t.capacity, r = t.roundsFull + t.roundsPartial, s = [];
  for (let a = 0; a < r; a++) {
    const i = [];
    for (let c = 0; c < n; c++)
      i.push(Mc(t.Fp, "Hades", n * a + c));
    s.push(i);
  }
  const o = hc({
    ...t,
    t: n,
    sboxPower: 3,
    reversePartialPowIdx: !0,
    mds: e,
    roundConstants: s
  });
  return o.m = n, o.rate = t.rate, o.capacity = t.capacity, o;
}
zc({ Fp: Vc, rate: 2, capacity: 1, roundsFull: 8, roundsPartial: 83 }, Gc);
var Oe;
(function(t) {
  t.NOT_STARTED = "NOT_STARTED", t.ONGOING = "ONGOING", t.AWAITING_FUNDS = "AWAITING_FUNDS", t.AWAITING_COMPLETION = "AWAITING_COMPLETION", t.COMPLETED = "COMPLETED", t.CANCELLED = "CANCELLED", t.ERROR = "ERROR";
})(Oe || (Oe = {}));
const qc = f.object({
  recoveryId: f.number()
}), Ou = f.object({
  feeToken: se,
  signerSignature: f.object({
    type: f.literal("StarknetKey"),
    signer: f.object({
      publicKey: Pt,
      r: Pt,
      s: Pt
    })
  })
}), Wc = f.nativeEnum(Oe), Fr = f.object({
  recoveryId: f.number(),
  status: Wc,
  completionTime: f.array(f.number()).optional()
}), Kc = f.object({
  activeRecovery: Fr.optional().or(f.null()).optional(),
  minFees: f.record(f.number()).optional()
}), Zc = f.object({
  recovery: Fr.optional().or(f.null()).optional(),
  minFees: f.record(f.number()).optional()
});
var ke;
(function(t) {
  t.UNDEPLOYED_ACCOUNT = "undeployedAccount", t.NOT_ENOUGH_TO_PAY_FEES = "notEnoughToPayFees", t.RECOVERY_ALREADY_EXISTS = "recoveryAlreadyExists";
})(ke || (ke = {}));
const Yc = f.nativeEnum(ke), ku = f.object({
  status: Yc
});
class Pu {
  constructor(e, n) {
    this.apiBase = e, this.httpService = n;
  }
  /**
   * Retrieves the on-chain recovery details for a given address and recovery ID.
   * If no recovery ID is provided, it retrieves the latest recovery details.
   * @param address - The address to retrieve the recovery details.
   * @param recoveryId - The recovery ID to retrieve the details.
   * @returns A promise that resolves to the on-chain recovery details.
   */
  async getRecovery(e, n) {
    const r = k(this.apiBase, "accounts", "starknet", e, "recovery", `${n}`), s = await this.httpService.get(r), o = Zc.safeParse(s);
    return o.error ? null : o.data;
  }
  /**
   * Retrieves the on-chain recovery details for a given address and recovery ID.
   * If no recovery ID is provided, it retrieves the latest recovery details.
   * @param address - The address to retrieve the current active recovery details.
   * @returns A promise that resolves to the on-chain recovery details.
   */
  async getActiveRecovery(e) {
    const n = k(this.apiBase, "accounts", "starknet", e, "recovery"), r = await this.httpService.get(n), s = Kc.safeParse(r);
    return s.error ? null : s.data;
  }
  /**
   * Starts the recovery process for a given address.
   * @param address - The address to recover.
   * @param feeToken - The token to be used for the recovery fee.
   * @param publicKey - The public key of the signer.
   * @param privateKey - The private key of the signer.
   * @returns A promise that resolves to the recovery details.
   */
  async startRecovery(e, n, r, s) {
    const { r: o, s: a } = us.starkCurve.sign(Lc(Hc(ys("utf8", "starknet:recovery")), r), s), i = {
      feeToken: n,
      signerSignature: {
        type: "StarknetKey",
        signer: {
          publicKey: r,
          r: $t.addHexPrefix(o.toString(16)),
          s: $t.addHexPrefix(a.toString(16))
        }
      }
    };
    return await this.httpService.post(`${this.apiBase}/accounts/starknet/${e}/recovery`, {
      body: JSON.stringify(i)
    }, qc);
  }
  /**
   * Completes the recovery process for a given address and recovery ID.
   * @param address - The address to recover.
   * @param recoveryId - The recovery ID to complete.
   * @returns A promise that resolves to the recovery details
   *
   */
  async completeRecovery(e, n) {
    const r = k(this.apiBase, "accounts", "starknet", e, "recovery", `${n}`, "complete");
    return await this.httpService.post(r);
  }
}
async function Ru() {
  if ("brave" in navigator)
    try {
      return await navigator.brave.isBrave();
    } catch {
    }
  return !1;
}
let Te;
function Xc() {
  return Te || (Te = new bs(navigator.userAgent).getResult()), Te;
}
function me(t) {
  return Xc().browser.name === t;
}
function $u() {
  return me("Firefox");
}
function Fu() {
  return me("Chrome");
}
function Uu() {
  return me("Safari");
}
function ju() {
  return me("Edge");
}
const Lu = f.string().refine((t) => Ss(t, Es), "Invalid seedphrase"), Ye = [
  {
    address: "0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7",
    name: "Ether",
    symbol: "ETH",
    decimals: 18,
    networkId: "mainnet-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/eth.png"
  },
  {
    address: "0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7",
    name: "Ether",
    symbol: "ETH",
    decimals: 18,
    networkId: "sepolia-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/eth.png"
  },
  {
    address: "0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7",
    name: "Ether",
    symbol: "ETH",
    decimals: 18,
    networkId: "localhost",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/eth.png"
  },
  {
    address: "0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d",
    name: "Starknet",
    symbol: "STRK",
    decimals: "18",
    networkId: "mainnet-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/strk.png"
  },
  {
    address: "0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d",
    name: "Starknet",
    symbol: "STRK",
    decimals: "18",
    networkId: "integration",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/strk.png"
  },
  {
    address: "0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d",
    name: "Starknet",
    symbol: "STRK",
    decimals: "18",
    networkId: "sepolia-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/strk.png"
  },
  {
    address: "0x00da114221cb83fa859dbdb4c44beeaa0bb37c7537ad5ae66fe5e0efd20e6eb3",
    name: "DAI",
    symbol: "DAI",
    decimals: 18,
    networkId: "mainnet-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/dai.png"
  },
  {
    address: "0x03e85bfbb8e2a42b7bead9e88e9a1b19dbccf661471061807292120462396ec9",
    name: "DAI",
    symbol: "DAI",
    decimals: 18,
    networkId: "sepolia-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/dai.png"
  },
  {
    address: "0x06f2a0dfeff180133de890ad69c6ba294574c5f34a67890fd22464f348c4d03c",
    name: "DAI",
    symbol: "DAI",
    decimals: 18,
    networkId: "sepolia-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/dai.png"
  },
  {
    address: "0x03fe2b97c1fd336e750087d68b9b867997fd64a2661ff3ca5a7c771641e8e7ac",
    name: "Wrapped BTC",
    symbol: "WBTC",
    decimals: 8,
    networkId: "mainnet-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/wbtc.png"
  },
  {
    address: "0x12d537dc323c439dc65c976fad242d5610d27cfb5f31689a0a319b8be7f3d56",
    name: "Wrapped BTC",
    symbol: "WBTC",
    decimals: 8,
    networkId: "sepolia-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/wbtc.png"
  },
  {
    address: "0x020d208b9e57a7f92bfa9f61135446e0961afc340378be97dbd317453c0950ae",
    name: "Wrapped BTC",
    symbol: "WBTC",
    decimals: 8,
    networkId: "sepolia-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/wbtc.png"
  },
  {
    address: "0x053c91253bc9682c04929ca02ed00b3e423f6710d2ee7e0d5ebb06f3ecf368a8",
    name: "USD Coin",
    symbol: "USDC",
    decimals: 6,
    networkId: "mainnet-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/usdc.png"
  },
  {
    address: "0x005a643907b9a4bc6a55e9069c4fd5fd1f5c79a22470690f75556c4736e34426",
    name: "USD Coin",
    symbol: "USDC",
    decimals: 6,
    networkId: "sepolia-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/usdc.png"
  },
  {
    address: "0x07ab0b8855a61f480b4423c46c32fa7c553f0aac3531bbddaa282d86244f7a23",
    name: "USD Coin",
    symbol: "USDC",
    decimals: 6,
    networkId: "sepolia-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/usdc.png"
  },
  {
    address: "0x068f5c6a61780768455de69077e07e89787839bf8166decfbf92b645209c0fb8",
    name: "Tether USD",
    symbol: "USDT",
    decimals: 6,
    networkId: "mainnet-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/usdt.png"
  },
  {
    address: "0x386e8d061177f19b3b485c20e31137e6f6bc497cc635ccdfcab96fadf5add6a",
    name: "Tether USD",
    symbol: "USDT",
    decimals: 6,
    networkId: "sepolia-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/usdt.png"
  },
  {
    address: "0x00585c32b625999e6e5e78645ff8df7a9001cf5cf3eb6b80ccdd16cb64bd3a34",
    name: "zkLend Token",
    symbol: "ZEND",
    decimals: 18,
    networkId: "mainnet-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/zend.png"
  },
  {
    address: "0x06ea04cd7e40bfef07c3625e2b3472839093d966bf601568128436466f962fcf",
    name: "Baby Laika",
    symbol: "BABYLAIKA",
    decimals: 18,
    networkId: "mainnet-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/babylaika.png"
  },
  {
    address: "0x004a8ff6a7b121c55d5e21af478265c5798f574abaa41efadf569d6939705896",
    name: "Baby Laika",
    symbol: "BABYLAIKA",
    decimals: 18,
    networkId: "sepolia-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/babylaika.png"
  },
  {
    address: "0x0782f0ddca11d9950bc3220e35ac82cf868778edb67a5e58b39838544bc4cd0f",
    name: "Starknet Voting Token",
    symbol: "vSTRK",
    decimals: 18,
    networkId: "mainnet-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/vstrk.png"
  },
  {
    address: "0x075afe6402ad5a5c20dd25e10ec3b3986acaa647b77e4ae24b0cbc9a54a27a87",
    name: "Ekubo Protocol",
    symbol: "EKUBO",
    decimals: 18,
    networkId: "mainnet-alpha",
    image: "https://dv3jj1unlp2jl.cloudfront.net/128/color/ekubo.png"
  }
], Jc = async (t, e, n) => {
  const r = await n.callContract({
    contractAddress: t,
    entrypoint: "balanceOf",
    calldata: [e]
  });
  return BigInt(O.toHex(Ht.uint256ToBN({
    low: r[0],
    high: r[1]
  })));
}, Du = async (t, e, n) => {
  const r = Ye.filter((o) => o.networkId === t);
  return (await Promise.allSettled(r.map((o) => e.callContract({
    contractAddress: o.address,
    entrypoint: "balanceOf",
    calldata: [n]
  })))).reduce((o, a, i) => {
    if (a.status === "fulfilled" && ms(a.value) || a.status === "rejected" || a.value[0] === "0x0" && a.value[1] === "0x0")
      return o;
    const c = BigInt(O.toHex(Ht.uint256ToBN({
      low: a.value[0],
      high: a.value[1]
    }))), l = {
      ...r[i],
      balance: c
    };
    return o.push(l), o;
  }, []);
}, Hu = async () => Ye, Vu = ({ address: t, networkId: e }) => Ye.find((r) => r.address === t && r.networkId === e), Mu = ({ amount: t, decimals: e, unitCurrencyValue: n }) => {
  if (!Y(t) || !Y(e) || !Y(n))
    return;
  const r = Number(e), s = BigInt(t) * Le(n.toString()).value;
  return Mt({
    value: s,
    decimals: r + Vt
  });
}, Gu = ({ unitAmount: t, decimals: e }) => {
  if (t === void 0 || !Y(t) || e === void 0 || !Y(e))
    return;
  const n = Number(e);
  return xt(t.toString(), n).value.toString();
}, zu = (t) => Y(t) ? Number(t) : 18, { UINT_256_MAX: Qc } = Ht, tl = (t) => String(t) === String(Qc), qu = (t, e = "$", n) => {
  if (t === void 0 || !Y(t))
    return null;
  const r = wi(t, n);
  return [e, r].filter(Boolean).join("");
}, el = "Unlimited", Wu = ({ amount: t, decimals: e, symbol: n, showPlusSign: r = !1, withSymbol: s = !0, unlimitedText: o = el, prettyConfigOverrides: a }) => {
  if (!Y(t))
    return null;
  let i, c = !1;
  if (tl(t))
    i = o;
  else {
    const d = Number(e), u = BigInt(t);
    c = u > 0n;
    const y = d > 0 ? Mt({ value: u, decimals: d }) : u.toString();
    i = d > 0 ? yi(y, a) : y;
  }
  const l = [i, s && n].filter(Boolean).join(" ");
  return r && c ? `+${l}` : l;
};
var nl = Jr, rl = nl;
function sl(t, e) {
  function n(r, s) {
    var o = e || {}, a;
    "randomize" in o || (o.randomize = !0), a = rl.operation(o);
    function i(d) {
      s(d || new Error("Aborted"));
    }
    function c(d, u) {
      if (d.bail) {
        i(d);
        return;
      }
      a.retry(d) ? o.onRetry && o.onRetry(d, u) : s(a.mainError());
    }
    function l(d) {
      var u;
      try {
        u = t(i, d);
      } catch (y) {
        c(y, d);
        return;
      }
      Promise.resolve(u).then(r).catch(function(m) {
        c(m, d);
      });
    }
    a.attempt(l);
  }
  return new Promise(n);
}
var ol = sl;
const al = /* @__PURE__ */ Qr(ol);
class Ku {
  constructor(e, n) {
    this.apiBase = e, this.httpService = n, this.TOKENS_INFO_URL = "/tokens/info", this.TOKENS_DEFI_DECOMPOSITION_URL = "/tokens/defi/decomposition";
  }
  /**
   * Fetch tokens info from backend
   * @param {Address} tokenAddress - The token address.
   * @returns {Promise<ApiTokenInfo[]>} - The fetched tokens or undefined if there was an error or not default network
   */
  async fetchTokensInfoFromBackend(e) {
    const n = k(this.apiBase, this.TOKENS_INFO_URL, e ?? "", "?chain=starknet"), r = await this.httpService.get(n), s = ts.safeParse(r);
    if (s.success)
      return s.data.tokens;
    const o = es.safeParse(r);
    if (o.success)
      return [o.data];
  }
  /**
   * Fetch list of tokens and balances for given account from backend
   * @param {Address} address - The account address.
   * @returns {Promise<BaseTokenWithBalance[]>} - The fetched balances for the account address.
   */
  async fetchAddressTokenBalancesFromBackend(e, n, r) {
    const s = k(this.apiBase, "activity", "starknet", n, "account", e, "balance");
    return (await al(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      async (i) => {
        let c;
        try {
          c = await this.httpService.get(s);
        } catch {
          return i(new Error("Error fetching")), [];
        }
        const l = ns.safeParse(c);
        if (!l.success)
          return i(new Error("Error parsing response")), [];
        if (l.data.status !== "initialised")
          throw new Error("Not initialised yet");
        return l.data.balances;
      },
      {
        /** seems to take 5-10 sec for initialised state */
        retries: 5,
        minTimeout: 5e3,
        ...r
      }
    )).map((i) => ({
      address: i.tokenAddress,
      balance: i.tokenBalance,
      networkId: n
    }));
  }
  async fetchDefiDecomposition(e) {
    const n = k(this.apiBase, this.TOKENS_DEFI_DECOMPOSITION_URL, e, "?chain=starknet"), r = await this.httpService.get(n);
    if (!rs.safeParse(r).success)
      throw new ss({ code: "TOKEN_DEFI_DECOMPOSITION_PARSING_ERROR" });
    return r.dapps;
  }
}
const Zu = (t, e, n, r) => ({
  contractAddress: t,
  entrypoint: "transfer",
  calldata: mt.compile({
    recipient: e,
    amount: jt(bi(n, r))
  })
}), Yu = (t, e, n, r) => ({
  contractAddress: t,
  entrypoint: "transferFrom",
  calldata: mt.compile({
    from_: e,
    to: n,
    tokenId: jt(r)
    // OZ specs need a uint256 as tokenId
  })
}), Xu = (t, e, n, r) => ({
  contractAddress: t,
  entrypoint: "safeTransferFrom",
  calldata: mt.compile({
    from_: e,
    to: n,
    tokenId: jt(r),
    amount: jt(1),
    data_len: "0"
  })
});
function Ur(t) {
  return Fe(t.unit) === "WEI";
}
function il(t) {
  return Fe(t.unit) === "FRI";
}
function At(t, e) {
  return Ur(t) ? {
    ...t,
    maxFee: e(t.maxFee),
    overallFee: e(t.overallFee),
    gasPrice: e(t.gasPrice),
    gasUsage: e(t.gasUsage)
  } : {
    ...t,
    overallFee: e(t.overallFee),
    gasPrice: e(t.gasPrice),
    gasUsage: e(t.gasUsage),
    maxAmount: e(t.maxAmount),
    maxPricePerUnit: e(t.maxPricePerUnit)
  };
}
function Rt(t) {
  return Ur(t) ? {
    maxFee: t.maxFee
  } : {
    amount: t.maxAmount,
    pricePerUnit: t.maxPricePerUnit
  };
}
function Be(t) {
  return il({ unit: t }) ? $e : Vn;
}
function Ju(t, e, n = 2) {
  const r = BigInt(10 ** n), s = BigInt(Math.round(e * 10 ** n));
  return t * s / r;
}
const Qu = [$e], jr = (t, e = fl) => {
  if (t.max && "amount" in t.max)
    return {
      ...t,
      ...t.max
    };
  const n = 10000n, { amount: r, pricePerUnit: s, dataGasConsumed: o = 0n, dataGasPrice: a = 0n } = t, i = r * s + o * a;
  if (i < 0)
    throw Error("Cannot calculate max fee for negative fee");
  const c = O.toBigInt(is({ estimatedFee: i })), l = Number(c) / Number(i), d = e(l), u = BigInt(Math.trunc(d * Number(n)));
  return {
    ...t,
    amount: r * u / n,
    pricePerUnit: s * u / n,
    dataGasConsumed: o * u / n,
    dataGasPrice: a * u / n
  };
}, re = (t) => {
  const { amount: e, pricePerUnit: n, dataGasConsumed: r = 0n, dataGasPrice: s = 0n } = t;
  return e * n + r * s;
}, cl = (t) => {
  if (t.max)
    return "maxFee" in t.max ? t.max.maxFee : re(t.max);
}, Pe = (t) => {
  const e = cl(t);
  return e || re(jr(t));
}, td = (t) => {
  if (t.deployment && !nt(t.deployment.feeTokenAddress, t.transactions.feeTokenAddress))
    throw Error("Cannot calculate estimated fees for different tokens");
  const e = re(t.transactions), n = t.deployment ? re(t.deployment) : 0n;
  return e + n;
}, ed = (t) => {
  if (t.deployment && !nt(t.deployment.feeTokenAddress, t.transactions.feeTokenAddress))
    throw Error("Cannot calculate estimated fees for different tokens");
  const e = t.deployment ? Pe(t.deployment) : 0n, n = Pe(t.transactions);
  return e + n;
}, nd = (t, e) => [
  {
    contractAddress: t,
    entrypoint: "transfer",
    calldata: mt.compile(os.parse({
      // We are using a dummy address (ETH here) as recipient to estimate the fee given we don't have a receipient yet
      recipient: e,
      // We are using the smallest possible amount to make sure this doesn't throw an error
      amount: Ht.bnToUint256(BigInt(1))
    }))
  }
], ll = (t, e) => {
  if (!t)
    return {
      transactions: {
        feeTokenAddress: e ?? Vn,
        amount: 0n,
        pricePerUnit: 0n,
        dataGasConsumed: 0n,
        dataGasPrice: 0n
      }
    };
  if (!Array.isArray(t))
    throw Error(`Unexpected simulation response. Expected array. Got ${typeof t}`);
  if (t.length === 1) {
    const n = ye.parse(t[0].feeEstimation);
    return {
      transactions: {
        feeTokenAddress: Be(n.unit),
        amount: O.toBigInt(n.gasUsage),
        pricePerUnit: O.toBigInt(n.gasPrice),
        max: Rt(At(n, O.toBigInt)),
        dataGasConsumed: n.dataGasConsumed ? O.toBigInt(n.dataGasConsumed) : 0n,
        dataGasPrice: n.dataGasPrice ? O.toBigInt(n.dataGasPrice) : 0n
      }
    };
  }
  if (t.length === 2) {
    const n = ye.parse(t[0].feeEstimation), r = ye.parse(t[1].feeEstimation);
    return {
      deployment: {
        feeTokenAddress: Be(n.unit),
        amount: O.toBigInt(n.gasUsage),
        pricePerUnit: O.toBigInt(n.gasPrice),
        max: Rt(At(n, O.toBigInt)),
        dataGasConsumed: n.dataGasConsumed ? O.toBigInt(n.dataGasConsumed) : 0n,
        dataGasPrice: n.dataGasPrice ? O.toBigInt(n.dataGasPrice) : 0n
      },
      transactions: {
        feeTokenAddress: Be(r.unit),
        amount: O.toBigInt(r.gasUsage),
        pricePerUnit: O.toBigInt(r.gasPrice),
        max: Rt(At(r, O.toBigInt)),
        dataGasConsumed: r.dataGasConsumed ? O.toBigInt(r.dataGasConsumed) : 0n,
        dataGasPrice: r.dataGasPrice ? O.toBigInt(r.dataGasPrice) : 0n
      }
    };
  }
  throw Error("Unexpected simulation response length");
}, ul = ({ transaction: t, nonce: e, chainId: n, version: r, isDeploymentTransaction: s, cairoVersion: o, address: a, appDomain: i }) => {
  let c = e;
  s && t.type !== "DEPLOY_ACCOUNT" && (c = O.toHex(1));
  const l = oe(t.calls);
  return {
    type: t.type,
    chainId: n,
    cairoVersion: o,
    nonce: c,
    version: r,
    account: a,
    calls: l,
    calldata: t.calldata,
    salt: t.salt,
    signature: t.signature,
    classHash: t.classHash,
    appDomain: i
    // appDomain: "https://starknetkit-blacked-listed.vercel.app", // to simulate blacklisted domain
  };
}, dl = (t, e) => {
  const { transactions: n } = t, r = n.map((c) => {
    if (!c.simulation)
      throw new as({ code: "SIMULATE_AND_REVIEW_FAILED" });
    return c;
  }), s = r.map((c) => ({
    ...c.simulation,
    feeEstimation: At(c.simulation.feeEstimation, Number)
  })), o = ll(s, e), [a, i] = r.length === 1 ? [r[0], void 0] : [r[1], r[0]];
  return {
    ...o,
    transactions: {
      ...o.transactions,
      dataGasConsumed: o.transactions.dataGasConsumed ?? 0n,
      dataGasPrice: o.transactions.dataGasPrice ?? 0n,
      max: Rt(At(a.simulation.feeEstimation, O.toBigInt))
    },
    deployment: o.deployment && i ? {
      ...o.deployment,
      dataGasConsumed: o.deployment.dataGasConsumed ?? 0n,
      dataGasPrice: o.deployment.dataGasPrice ?? 0n,
      max: Rt(At(i.simulation.feeEstimation, O.toBigInt))
    } : void 0
  };
}, rd = (t) => {
  const e = jr(t), n = Pe(t);
  return {
    // for v1 transactions
    maxFee: n,
    // for v3 transactions
    resourceBounds: {
      l1_gas: {
        // (overall_fee / gas_price) × gas_safety_margin
        max_amount: O.toHex(n / t.pricePerUnit),
        // max_price_per_unit: gas_price × fee_safety_margin
        max_price_per_unit: O.toHex(e.pricePerUnit)
      },
      l2_gas: {
        max_amount: "0x0",
        max_price_per_unit: "0x0"
      }
    }
  };
}, sd = (t) => {
  const e = Math.sqrt(t);
  return isNaN(e) ? Math.sqrt(2) : e;
}, fl = (t) => {
  const e = Math.cbrt(t);
  return isNaN(e) ? Math.cbrt(2) : e;
}, od = (t) => t < 1 || isNaN(t) ? 1.1 : Math.log(t + 1) + 1, hl = [$e];
function Xe({ address: t }) {
  return hl.some((e) => nt(t, e));
}
function ad(t) {
  return t ? Aa().some((e) => nt(e, t)) : !1;
}
function Un(t) {
  return Xe({
    address: t
  }) ? Z.TRANSACTION_VERSION.V3 : Z.TRANSACTION_VERSION.V1;
}
function id(t) {
  return Xe({ address: t }) ? Z.TRANSACTION_VERSION.F3 : Z.TRANSACTION_VERSION.F1;
}
function cd(t, e) {
  return ds(e.contract) ? Xe({ address: t }) ? Z.TRANSACTION_VERSION.V3 : Z.TRANSACTION_VERSION.V2 : Z.TRANSACTION_VERSION.V1;
}
class ld {
  constructor(e, n) {
    this.apiBase = e, this.httpService = n;
  }
  /**
   * Fetch transaction review labels
   * @returns {Promise<TransactionReviewLabel[] | undefined>} The account activities.
   */
  async getLabels() {
    const e = k(this.apiBase, "reviewer", "labels");
    return await this.httpService.get(e);
  }
  /**
   * Fetch transaction review warnings.
   * @returns {Promise<TransactionReviewWarning[] | undefined>} The account activities.
   */
  async getWarnings() {
    const e = k(this.apiBase, "reviewer", "warnings/reasons");
    return await this.httpService.get(e);
  }
  async simulateAndReview(e, n, r, s, o, a) {
    const i = n.some((c) => c.type === "DEPLOY_ACCOUNT");
    try {
      if (!("getChainId" in e))
        throw new Error("MISSING_METHOD");
      const c = Un(r), l = i ? "0x0" : await e.getNonce(), d = await e.getChainId(), u = {
        transactions: n.map((w) => ({
          ...ul({
            transaction: w,
            nonce: l,
            version: c,
            chainId: d,
            isDeploymentTransaction: i,
            appDomain: s,
            cairoVersion: e.cairoVersion,
            address: e.address
          }),
          type: w.type
        }))
      }, y = k(this.apiBase, "reviewer", "transactions", "v2", "review", "starknet"), m = a ? Si(y, { delayedTransactions: "true" }) : y, S = await this.httpService.post(m, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(u)
      }, cs);
      if (S.transactions.some((w) => ls(w)))
        return S;
      const g = dl(S, r);
      return {
        ...S,
        enrichedFeeEstimation: g
      };
    } catch (c) {
      return console.error(c), this.fallbackToOnchainFeeEstimation({
        transactions: n,
        account: e,
        isDeploymentTransaction: i,
        feeTokenAddress: r,
        accountDeployTransaction: o
      });
    }
  }
  getCallsFromTx(e) {
    let n;
    return e.calls && (n = oe(e.calls)), n;
  }
  async fallbackToOnchainFeeEstimation({ transactions: e, account: n, isDeploymentTransaction: r, feeTokenAddress: s, accountDeployTransaction: o }) {
    try {
      const a = r ? this.getCallsFromTx(e[1]) : this.getCallsFromTx(e[0]);
      if (!a)
        throw new _t({
          code: "NO_CALLS_FOUND"
        });
      const i = await this.fetchFeesOnchain({
        starknetAccount: n,
        calls: a,
        isDeployed: !r,
        feeTokenAddress: s,
        accountDeployTransaction: o
      });
      return {
        transactions: [],
        enrichedFeeEstimation: i,
        isBackendDown: !0
      };
    } catch (a) {
      throw console.error(a), new _t({
        message: `${a}`,
        code: "SIMULATE_AND_REVIEW_FAILED"
      });
    }
  }
  async fetchFeesOnchain({ starknetAccount: e, calls: n, isDeployed: r, feeTokenAddress: s, accountDeployTransaction: o }) {
    try {
      const a = Un(s), i = {
        transactions: {
          feeTokenAddress: s,
          amount: 0n,
          pricePerUnit: 0n,
          dataGasConsumed: 0n,
          dataGasPrice: 0n
        }
      };
      if (!r && o) {
        if ("estimateFeeBulk" in e) {
          const c = [
            {
              type: ln.DEPLOY_ACCOUNT,
              payload: {
                classHash: o.classHash,
                addressSalt: o.salt,
                constructorCalldata: o.calldata,
                contractAddress: e.address
              }
            },
            {
              type: ln.INVOKE,
              payload: n
            }
          ], [l, d] = await e.estimateFeeBulk(c, {
            version: a
          }).catch((u) => {
            throw console.error(u), u;
          });
          if (!l.gas_consumed || !l.gas_price || !d.gas_consumed || !d.gas_price)
            throw new _t({
              code: "ONCHAIN_FEE_ESTIMATION_FAILED",
              message: "Missing gas_consumed or gas_price"
            });
          i.deployment = {
            feeTokenAddress: s,
            amount: l.gas_consumed,
            pricePerUnit: l.gas_price,
            dataGasConsumed: l.data_gas_consumed,
            dataGasPrice: l.data_gas_price
          }, i.transactions = {
            feeTokenAddress: s,
            amount: d.gas_consumed,
            pricePerUnit: d.gas_price,
            dataGasConsumed: d.data_gas_consumed,
            dataGasPrice: d.data_gas_price
          };
        }
      } else {
        const { gas_consumed: c, gas_price: l, data_gas_consumed: d, data_gas_price: u } = await e.estimateFee(n, {
          skipValidate: !0,
          version: a
        });
        if (!c || !l)
          throw new _t({
            code: "ONCHAIN_FEE_ESTIMATION_FAILED",
            message: "Missing gas_consumed or gas_price"
          });
        i.transactions = {
          feeTokenAddress: s,
          amount: c,
          pricePerUnit: l,
          dataGasConsumed: d,
          dataGasPrice: u
        };
      }
      return i;
    } catch (a) {
      throw new _t({
        code: "ONCHAIN_FEE_ESTIMATION_FAILED",
        message: `${a}`
      });
    }
  }
}
const ud = [
  "account-upgrade",
  "approve",
  "set-approval-for-all",
  "swap",
  "transfer"
], dd = (t) => ({ showBalanceChange: vt(() => {
  const n = t == null ? void 0 : t.some((s) => !dn(s.transfers)), r = t == null ? void 0 : t.some((s) => !dn(s.approvals));
  return t && (n || r);
}, [t]) }), ge = (t) => t ? t.filter((e) => e.token.type === "erc20") : [], fd = (t) => vt(() => ge(t), [t]), hd = (t) => ge(t).length > 0, pd = (t) => ge(t).some((n) => n.amount > 0n), md = (t) => ge(t).some((n) => n.amount < 0n), Lr = (t) => t ? t.filter((e) => e.token.type === "erc721") : [], gd = (t) => vt(() => Lr(t), [t]), pl = (t) => Lr(t).length > 0, wd = (t) => vt(() => pl(t), [t]), yd = (t, e) => vt(() => t && e ? [
  {
    contractAddress: t.address,
    entrypoint: "transfer",
    calldata: mt.compile({
      recipient: e,
      amount: jt(t.balance)
    })
  }
] : [], [t, e]), bd = ({ apiData: { apiBaseUrl: t, apiHeaders: e }, address: n, network: r, transactionReviewEnabled: s = !0, transactions: o }) => {
  const a = qn(async () => {
    if (!n || !r)
      return;
    if (!t)
      throw "Transaction review endpoint is not defined";
    const c = k(t, "reviewer/transactions/review/starknet"), l = gs(o) ? o : [o], d = {
      network: r,
      account: n,
      calls: l
    };
    return tr(c, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...e
      },
      body: JSON.stringify(d)
    });
  }, [n, r, o]), i = vt(() => As({ transactions: o, address: n, network: r }), [o, n, r]);
  return Ks(!!s, [i, "transactionReview"], a);
}, Sd = (t) => {
  if (!t)
    return {};
  const e = t.assessment === "warn" && t.reason !== "contract_is_not_verified", n = t.reason ? ` (Reason: ${Kn(t.reason)})` : "", r = e ? t.reason === "recipient_is_token_address" ? "You are sending tokens to their own address. This is likely to burn them." : `This transaction has been flagged as dangerous. We recommend you reject this transaction unless you are sure.${n}` : void 0;
  return {
    warn: e,
    reason: r
  };
}, ml = (t) => {
  var e;
  if (t) {
    for (const n of t.reviews)
      if (((e = n.activity) == null ? void 0 : e.type) === "swap")
        return n;
  }
}, Ed = (t) => {
}, Ad = (t, e) => {
  var n;
  if (e) {
    for (const r of e.reviews)
      if (((n = r.activity) == null ? void 0 : n.type) === t)
        return r.activity;
  }
}, xd = (t) => !!ml(t), vd = (t) => {
  var e, n;
  if (t) {
    for (const r of t.reviews)
      if ((e = r.activity) != null && e.type)
        return {
          ...r,
          type: (n = r.activity) == null ? void 0 : n.type
        };
  }
}, gl = async ({ feeTokenAddress: t, calls: e, selectedAccount: n, transactionReviewService: r, appDomain: s, accountDeployTransaction: o, isDelayedTransaction: a }) => {
  const i = {
    type: "INVOKE",
    calls: oe(e)
  };
  if (!n || !t)
    return;
  const c = o ? [o, i] : [i];
  return { result: await r.simulateAndReview(n, c, t, s, o, a) };
}, wl = async (t, e, n, r) => {
  var y, m, S, h, g, w;
  let s = !1;
  const o = e.transactions.find((E) => {
    var x, _;
    return (_ = (x = E == null ? void 0 : E.simulation) == null ? void 0 : x.summary) == null ? void 0 : _.find((B) => B.sent);
  });
  if (!o || !((y = o.simulation) != null && y.summary))
    return s;
  const a = o.simulation.summary.filter((E) => E.sent).map((E) => E.token.address);
  if (!(((m = e.enrichedFeeEstimation) == null ? void 0 : m.transactions.feeTokenAddress) && a.includes((S = e.enrichedFeeEstimation) == null ? void 0 : S.transactions.feeTokenAddress)) || !((g = (h = e.enrichedFeeEstimation) == null ? void 0 : h.transactions) != null && g.max))
    return s;
  const c = "amount" in e.enrichedFeeEstimation.transactions.max ? e.enrichedFeeEstimation.transactions.max.amount * e.enrichedFeeEstimation.transactions.max.pricePerUnit : "maxFee" in e.enrichedFeeEstimation.transactions.max ? e.enrichedFeeEstimation.transactions.max.maxFee : void 0, l = (w = o.simulation.summary.find((E) => E.sent && E.token.address === n)) == null ? void 0 : w.value;
  if (!c || !l)
    return s;
  const d = await Jc(n, t, r) ?? 0n;
  return BigInt(d) > c + BigInt(l) || (s = !0), s;
}, Id = () => qn(async ({ feeTokenAddress: e, calls: n, selectedAccount: r, transactionReviewService: s, appDomain: o, accountDeployPayload: a, provider: i, isDelayedTransaction: c }) => {
  if (!r)
    return;
  const l = await gl({
    feeTokenAddress: e,
    calls: n,
    selectedAccount: r,
    transactionReviewService: s,
    appDomain: o,
    accountDeployTransaction: yl(a),
    isDelayedTransaction: c
  });
  if (!l || !l.result || !e)
    return;
  const d = await wl(r.address, l.result, e, i);
  return { ...l.result, isSendingMoreThanBalanceAndGas: d };
}, []), yl = (t) => t ? {
  type: "DEPLOY_ACCOUNT",
  calldata: t.calldata,
  classHash: Pt.parse(t.class_hash),
  salt: Pt.parse(t.salt),
  signature: []
} : void 0;
function jn() {
  return { promise: Promise.resolve() };
}
function Td(t) {
  return class extends t {
    constructor({ enabled: e, appVersion: n }) {
      super(), this.enabled = e, this.appVersion = n;
    }
    track(e, n) {
      return !this.enabled || !super.isLoaded ? jn() : {
        promise: super.track(e, {
          app_version: this.appVersion,
          ...n
        }).promise
      };
    }
  };
}
const bl = fs({}), Bd = ({ enabled: t, initialize: e, children: n }) => {
  const [r, s] = zn(!1);
  return Ft(() => {
    !r && t && e().then(() => s(!0));
  }, [r, t, e]), /* @__PURE__ */ xs(bl.Provider, { value: {}, children: n });
};
export {
  tt as ARGENT_ACCOUNT_CONTRACT_CLASS_HASHES,
  Jt as ARGENT_MULTISIG_CONTRACT_CLASS_HASHES,
  kl as AddSmartAccountResponseSchema,
  Pl as AddSmartAcountRequestSchema,
  vs as BackendAccountSchema,
  Su as BackendNftService,
  Cd as BaseError,
  eo as C0_PROXY_CONTRACT_CLASS_HASHES,
  Hl as CacheService,
  Vt as DEFAULT_TOKEN_DECIMALS,
  Vl as DateService,
  Od as ESTIMATE_ERROR_MESSAGES,
  Vn as ETH_TOKEN_ADDRESS,
  as as EstimateError,
  kd as EventEmitterProvider,
  Pd as EventsBySelector,
  Rd as FEE_OVERHEAD,
  De as HTTPService,
  en as HTTP_ERROR_MESSAGE,
  K as HttpError,
  ru as KnownDappsBackendService,
  sn as MultiSigner,
  Pu as OnchainRecoveryService,
  el as PRETTY_UNLIMITED,
  Oe as RecoveryStatusEnum,
  ou as ResolveNameService,
  Kr as STANDARD_DEVNET_ACCOUNT_CLASS_HASH,
  $e as STRK_TOKEN_ADDRESS,
  Ml as SWRService,
  Zl as StarknetAddressService,
  ke as StartOnchainRecoveryErrorStatusEnum,
  $d as TOKEN_ERROR_MESSAGES,
  Fd as TXV1_ACCOUNT_CLASS_HASH,
  Ud as TXV1_MULTISIG_CLASS_HASH,
  jd as TXV3_ACCOUNT_CLASS_HASH,
  Ld as TXV3_MULTISIG_CLASS_HASH,
  ss as TokenError,
  Ku as TokenServiceWeb,
  ld as TransactionReviewServiceWeb,
  Bd as WebAmplitudeProvider,
  Td as WebAnalyticsServiceFactory,
  Dd as abiEntrySchema,
  Hd as abiSchema,
  Kc as activeOnchainRecoverySchema,
  Vd as addOwnersCalldataSchema,
  Md as addPluginCalldataSchema,
  Gd as addressInputCharactersAndLengthSchema,
  zd as addressInputSchema,
  qd as addressOrDomainInputSchema,
  Wd as addressOrDomainSchema,
  Kd as addressOrEmptyUndefinedSchema,
  se as addressSchema,
  Re as addressSchemaArgentBackend,
  Zd as addressSchemaBase,
  Yd as addressSchemaLooseLength,
  Xd as addressSchemaStrictLength,
  Jd as airdropSchema,
  ns as apiAccountTokenBalancesSchema,
  Qd as apiAirdropSchema,
  tf as apiCollateralizedDebtPositionSchema,
  ef as apiCollateralizedDebtPositionsSchema,
  nf as apiConcentratedLiquidityPositionSchema,
  rf as apiConcentratedLiquidityPositionsSchema,
  sf as apiDefiDecompositionProduct,
  of as apiDefiDecompositionProducts,
  af as apiDefiDecompositionSchema,
  cf as apiDefiDecompositionToken,
  rs as apiDefiPositionsSchema,
  lf as apiPriceDataResponseSchema,
  uf as apiPriceDetailsSchema,
  es as apiTokenInfoResponseSchema,
  df as apiTokenInfoSchema,
  ts as apiTokensInfoResponseSchema,
  ud as apiTransactionReviewActivityType,
  ff as apiUnclaimedRewardsSchema,
  hf as apiWalletResponseSchema,
  Bs as argentBackendNetworkIdSchema,
  is as argentMaxFee,
  pf as argentNameSchema,
  Ts as argentNetworkIdSchema,
  Dl as bigDecimal,
  mf as bigNumberSchema,
  gf as bigNumberishSchema,
  wf as booleanToStringSchema,
  yl as buildAccountDeployTransaction,
  Ia as buildConstructorCalldata,
  nd as buildDummyTx,
  yf as builtinsSchema,
  bf as byteCodeSchema,
  Sf as cairo1EventSchema,
  Ef as cairoAssemblySchema,
  Af as cairoVersionSchema,
  fl as calculateCubeRootAdjustment,
  od as calculateNonLinearAdjustment,
  sd as calculateSqrtAdjustment,
  xf as callDetailsSchema,
  Dr as callSchema,
  vf as calldataSchema,
  At as castFeeEstimation,
  If as changeGuardianCalldataSchema,
  Tf as changeThresholdCalldataSchema,
  wl as checkGasFeeBalance,
  ad as classHashSupportsTxV3,
  Bf as collateralizedDebtGroupSchema,
  _f as collateralizedDebtPositionSchema,
  Nf as collateralizedDebtPositionsSchema,
  Cf as compiledContractClassSchema,
  Of as compiledSierraCasmSchema,
  kf as compiledSierraSchema,
  Pf as compressedProgramSchema,
  Rf as concentratedLiquidityPositionSchema,
  $f as concentratedLiquidityPositionsSchema,
  Zr as constructorCallDataSchemaC0,
  Yr as constructorCallDataSchemaC1V1,
  Ff as contractEntryPointFieldsSchema,
  Mu as convertTokenAmountToCurrencyValue,
  Gu as convertTokenUnitAmountWithDecimals,
  _a as dappContractSchema,
  Ba as dappLinkSchema,
  uu as daysBetween,
  gi as decodeBase58,
  lu as decodeBase58Array,
  Uf as defiDappsProductsSchema,
  jf as defiPositionSchema,
  Lf as defiPositionTypeSchema,
  Df as defiProductSchema,
  Hf as defiProductsSchema,
  Vf as denyTxV3,
  mi as encodeBase58,
  cu as encodeBase58Array,
  oe as ensureArray,
  zu as ensureDecimals,
  yu as entryPointToHumanReadable,
  Mf as entryPointsByTypeSchema,
  Iu as equalNft,
  Zu as erc20TransferTransaction,
  Xu as erc721SafeTransferFromTransaction,
  Yu as erc721TransferFromTransaction,
  Gf as escapeGuardianCalldataSchema,
  Pe as estimatedFeeToMaxFeeTotal,
  rd as estimatedFeeToMaxResourceBounds,
  re as estimatedFeeToTotal,
  ed as estimatedFeesToMaxFeeTotal,
  td as estimatedFeesToTotal,
  zf as eventAbiSchema,
  qf as eventEntrySchema,
  Wf as executeOnPluginCalldataSchema,
  Xe as feeTokenNeedsTxV3Support,
  Kf as feltSchema,
  tr as fetchData,
  Xt as fetcherError,
  tu as findImplementationForAccount,
  Zf as findTransfersAndApprovals,
  or as formatAddress,
  Yf as formatFullAddress,
  Xf as formatTruncatedAddress,
  Jf as formatTruncatedSignerKey,
  Qf as formatTruncatedString,
  th as functionAbiSchema,
  eh as functionAbiTypeSchema,
  ee as generateAvatarImage,
  Ta as getAccountContractAddress,
  va as getAccountDeploymentPayload,
  ql as getAccountIdentifier,
  qr as getAddressFromArgentName,
  to as getAddressFromStarkName,
  pn as getArgentAccountClassHashes,
  Aa as getArgentAccountClassHashesWithTxV3Support,
  Ea as getArgentAccountWithMultiSignerClassHashes,
  Kl as getBackendTimeNowSeconds,
  Zs as getBackendTimeSeconds,
  Qs as getCallFromStarkName,
  Ys as getChainIdFromNetworkId,
  hi as getColor,
  ka as getDapplandLinkForDapp,
  su as getDapplandUrlForDapp,
  Sd as getDisplayWarnAndReasonForTransactionReview,
  ge as getERC20Transactions,
  Lr as getERC721Transactions,
  ll as getEstimatedFeeFromBulkSimulation,
  dl as getEstimatedFeeFromSimulationAndRespectWatermarkFee,
  di as getInitials,
  Xl as getLastCairo0ArgentAccountClassHash,
  Sa as getLatestArgentAccountClassHash,
  Yl as getLatestArgentMultisigClassHash,
  Ql as getLatestLedgerAccountClassHash,
  Jl as getLedgerAccountClassHashes,
  nh as getMessageFromTrpcError,
  Ed as getNFTTransferActivity,
  iu as getNetworkAccountImageUrl,
  vu as getNftPicture,
  ul as getPayloadFromTransaction,
  rh as getPrettyRpcError,
  gl as getReviewForTransactions,
  rn as getSignerForMultiSigner,
  id as getSimulationTxVersionFromFeeToken,
  Js as getStarknetIdContractAddressFromNetworkId,
  Jc as getTokenBalance,
  Hu as getTokens,
  Du as getTokensBalances,
  Ad as getTransactionReviewActivityOfType,
  xd as getTransactionReviewHasSwap,
  ml as getTransactionReviewSwap,
  vd as getTransactionReviewWithType,
  Un as getTxVersionFromFeeToken,
  cd as getTxVersionFromFeeTokenForDeclareContract,
  Xc as getUAParserResult,
  jt as getUint256CalldataFromBN,
  cl as getWatermarkedMaxFeeTotal,
  hd as hasERC20Transactions,
  pl as hasERC721Transactions,
  pd as hasIncomingERC20Transactions,
  md as hasOutgoingERC20Transactions,
  Pt as hexSchema,
  sh as hexSchemaBase,
  li as id,
  nn as implementationSchema,
  oh as includesAddress,
  ah as inputAmountSchema,
  Fl as isAccountV4,
  $l as isAccountV5,
  Rl as isAccountV6,
  Mr as isAddress,
  pu as isAllowedAddressHexInputValue,
  mu as isAllowedNumericInputValue,
  Ll as isArgentBackendNetworkId,
  zr as isArgentName,
  jl as isArgentNetworkId,
  Ru as isBraveBrowser,
  me as isBrowser,
  Fu as isChromeBrowser,
  fu as isContractDeployed,
  ju as isEdgeBrowser,
  nt as isEqualAddress,
  ih as isEqualArgentName,
  xa as isEqualImplementation,
  ch as isEqualStarknetDomainName,
  lh as isEqualStarknetId,
  il as isFRI,
  du as isFeatureEnabled,
  $u as isFirefoxBrowser,
  Y as isNumeric,
  Uu as isSafariBrowser,
  uh as isStarknetDomainName,
  Gr as isStarknetId,
  tl as isUnlimitedAmount,
  Vr as isValidAddress,
  dh as isValidInputAmount,
  Ur as isWEI,
  Hr as isZeroAddress,
  Ca as knownDappSchema,
  Oa as knownDappsSchema,
  fh as legacyContractClassSchema,
  hh as legacyEventSchema,
  ph as looseCalldataSchema,
  mh as modifySnjsFeeOverhead,
  gh as multiTypeSchema,
  Ju as multiplyBigIntByFloat,
  Ra as nameProviderResolutionSchema,
  $a as nameResolutionAddressSchema,
  Ua as nameResolutionAddressesSchema,
  sr as nameResolutionStarknetIdSchema,
  Pa as nameResolutionStarknetIdsSchema,
  hu as nonNullable,
  Hn as normalizeAddress,
  wh as normalizeAddressOrDomain,
  yh as normalizeArgentName,
  bh as normalizeStarknetId,
  Zc as onchainRecoverySchema,
  Sh as parseAmount,
  bi as parseAmountValue,
  gu as pluralise,
  Gl as postData,
  Ul as preferencesEndpointPayload,
  Is as preferencesSchema,
  wi as prettifyCurrencyNumber,
  qu as prettifyCurrencyValue,
  fr as prettifyNumber,
  Ve as prettifyNumberConfig,
  Wu as prettifyTokenAmount,
  yi as prettifyTokenNumber,
  Eh as productGroupsSchema,
  Ah as programSchema,
  Fa as providersNamesSchema,
  xh as pythonicHintsSchema,
  vh as rawArgsArraySchema,
  Ih as rawArgsObjectSchema,
  Th as rawArgsSchema,
  wu as readFileAsString,
  Fr as recoveryBaseSchema,
  Ou as recoveryBodySchema,
  Wc as recoveryStatusSchema,
  Bh as removeOwnersCalldataSchema,
  _h as removePluginCalldataSchema,
  Nh as replaceSignerCalldataSchema,
  Lu as seedphraseSchema,
  Ch as sierraContractEntryPointFieldsSchema,
  Oh as sierraEntryPointsByTypeSchema,
  kh as sierraProgramDebugInfoSchema,
  Xs as starkNameToCallDataDomain,
  Ph as starknetDomainNameSchema,
  Xr as starknetIdSchema,
  ku as startOnchainRecoveryErrorSchema,
  Yc as startOnchainRecoveryErrorStatusSchema,
  qc as startOnchainRecoverySchema,
  Rh as stringToBooleanSchema,
  pi as stripAddressZeroPadding,
  $h as structAbiSchema,
  Wl as swrRefetchDisabledConfig,
  Rt as toMax,
  Qu as tokensRequireTxV3Support,
  Fh as transactionReviewTransactionsSchema,
  Uh as transactionReviewWarningSchema,
  os as transferCalldataSchema,
  jh as trpcErrorSchema,
  Lh as txVersionSchema,
  Dh as uint256Schema,
  Hh as unclaimedRewardsSchema,
  Be as unitToFeeTokenAddress,
  Si as urlWithQuery,
  dd as useBalanceChange,
  Au as useCollection,
  Ks as useConditionallyEnabledSWR,
  eu as useDebounce,
  nu as useDebouncedValue,
  fd as useERC20Transactions,
  gd as useERC721Transactions,
  Vh as useEmitEvent,
  Mh as useEventEmitter,
  Gh as useEventEmitterContext,
  zh as useEventListener,
  wd as useHasERC721Transaction,
  qh as useIsEventEmitterEnabled,
  yd as useMaxAmountTransaction,
  xu as useNft,
  Eu as useNfts,
  Vu as useToken,
  bd as useTransactionReview,
  Id as useTransactionReviewV2webFetcher,
  Wh as validChecksumAddressSchema,
  Kh as validateAddressRangeSchema,
  bu as voidify,
  zl as withPolling
};
